<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>订单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">订单编号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.id" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">国内运单号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.trackingNumberCn" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
            <!-- <el-col
              :span="6"
              class="display-row"
            >
              <div class="query-title">国际运单号:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.trackingNumberJpn"
                  size="small"
                  @keyup.enter.native="searchList()"
                >
                </el-input>
              </div>
            </el-col> -->
            <el-col :span="6" class="display-row">
              <div class="query-title">用户ID:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title">国际物流状态:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.sagawaState" placeholder="请选择" size="small" clearable>
                  <el-option
                    v-for="item in sagawaStateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col> -->
            <el-col :span="6" class="display-row">
              <div class="query-title">仓库保管:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.categoryFlag" placeholder="请选择" size="small" clearable>
                  <el-option key="1" value="1" label="是"></el-option>
                  <el-option key="0" value="0" label="否"></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title">订单状态:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.orderStatus" placeholder="请选择" size="small" clearable>
                  <el-option
                    v-for="item in orderStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col> -->

            <el-col :span="6" class="display-row">
              <div class="query-title">下单开始日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>

            <el-col :span="6" class="display-row">
              <div class="query-title">下单结束日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">发送开始日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.sendTimeStart" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <!--<div class="query-title">发送结束日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.sendTimeEnd" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>-->
              <div class="query-title">商品编码:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入商品编码"
                  clearable
                  v-model="queryInfo.goodsCode"
                  size="small"
                  @keyup.enter.native="searchList()"
                >
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">购买账号:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.buyAccountId" placeholder="请选择" size="small" clearable>
                  <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>

            <el-col :span="6" class="display-row">
              <div class="query-title">购买订单号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.buyOrderNumber" size="small" @keyup.enter.native="searchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">物流更新:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.isCnLogisticsStatusUpdate" placeholder="请选择" size="small" clearable>
                  <el-option key="1" value="1" label="是（48小时内有更新）"></el-option>
                  <el-option key="0" value="0" label="否（超48小时未更新）"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">是否有仓储:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.whetherStorageFee" placeholder="请选择" size="small" clearable>
                  <el-option key="1" value="1" label="是"></el-option>
                  <el-option key="0" value="0" label="否"></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

          <el-row class="search-row">
            <el-col :span="12" class="display-row">
              <div class="query-title order-type-full-title">FBA/YFF/ZOZO/RSL/STOCKCREW:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.orderType" placeholder="请选择" size="small" clearable>
                  <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

        </el-collapse>
        <el-row class="search-row" style="margin-bottom: -5px; margin-right: -10px">
          <el-col :span="16" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 0 }" @click="searchList(-1, (index = 0))">
                全部</el-button>
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 1 }" @click="searchList(1, (index = 1))">
                待购买<span v-if="orderCount.pendingPurchaseCount > 0 ? true : false" class="lx-red">({{
                  orderCount.pendingPurchaseCount }})</span></el-button>
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 2 }" @click="searchList(2, (index = 2))">
                购买完<span v-if="orderCount.purchasedCount > 0 ? true : false" class="lx-red">({{ orderCount.purchasedCount
                }})</span></el-button>
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 3 }" @click="searchList(0, (index = 3))">
                等待到库<span v-if="orderCount.waitWarehouseCount > 0 ? true : false" class="lx-red">({{
                  orderCount.waitWarehouseCount }})</span></el-button>
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 4 }" @click="searchList(4, (index = 4))">
                已到货<span v-if="orderCount.arriverCount > 0 ? true : false" class="lx-red">({{ orderCount.arriverCount
                }})</span></el-button>
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 5 }" @click="searchList(5, (index = 5))">
                仓库保管中</el-button>
              <!-- <el-button
                class="search-btn lx-mb5 btn-white"
                :class="{lxBtnGreenDeep: curIndex === 9}"
                @click="searchList(9,index = 9)"
              >待发账单<span class="lx-red">({{orderCount.billingCount}})</span></el-button>
              <el-button
                class="search-btn lx-mb5 btn-white"
                :class="{lxBtnGreenDeep: curIndex === 6}"
                @click="searchList(6,index = 6)"
              >待支付<span class="lx-red">({{orderCount.waitPayCount}})</span></el-button> -->
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 7 }" @click="searchList(7, (index = 7))">
                不良订单<span v-if="orderCount.badOrderCount > 0 ? true : false" class="lx-red">({{ orderCount.badOrderCount
                }})</span></el-button>
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 10 }" @click="searchList(10, (index = 10))">无法购买</el-button>
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 8 }" @click="searchList(8, (index = 8))">
                已完成</el-button>
              <el-button class="search-btn lx-mb5 btn-white" :class="{ lxBtnGreenDeep: curIndex === 11 }" @click="searchList(11, (index = 11))">
                已取消</el-button>
            </div>
          </el-col>

          <el-col :span="8" class="display-row">
            <div class="search-btn-container">
              <!--              <el-button class="search-btn lx-mb5 btn-blue" @click="orderClearTimeSave">清空消息</el-button>-->
              <el-upload style="display: inline-block" action="" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                :on-success="handleSuccess" multiple :show-file-list="false" :on-exceed="handleExceed" :file-list="fileList" :http-request="excelUploadRequest">
                <el-button class="search-btn lx-mb5 btn-blue">批量维护</el-button>
              </el-upload>
              <el-button class="search-btn lx-mb5 btn-blue" @click="toSort">排序</el-button>
              <el-button class="search-btn lx-mb5 btn-blue" @click="orderExport">导出</el-button>
              <el-button class="search-btn lx-mb5 btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn lx-mb5 btn-blue" @click="searchList()">搜索</el-button>
              <el-button
                class="search-btn lx-mb5 btn-blue"
                v-if="queryInfo.orderStatus == '1' && curIndex == '1'"
                @click="exportActionTwo()"
              >
                导出加购
              </el-button>
              <el-button class="search-btn lx-mb5 btn-blue" @click="
                accountDialogVisible = true;
              batchAccount.buyAccountId = '';
              " :disabled="!orderDetailList.length">批量购买账号</el-button>
              <!--              <el-button class="search-btn lx-mb5 btn-blue" @click="cancelBatchUpdatePurchaseStatus">批量取消购买</el-button>-->
              <el-button class="search-btn lx-mb5 btn-blue" @click="batchUpdatePurchaseStatus">批量购买完</el-button>

              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt=""
                @click="isActive = !isActive">展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive">收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <draggable-table
            :columns="asyncColumns"
            :table-data="orderList"
            :show-selection="true"
            :header-cell-style="tableStyle.headerStyle"
            :show2-index="true"
            :indexFixed="'left'"
            :selectionFixed="'left'"
            class="draggableTable"
            :selectionWidth="25"
            :indexWidth="25"
            :draggable="true"
            @column-drop="handleColumnDrop"
            @column-close="handleColumnClose"
            @select="tableSelect"
            @select-all="tableSelectAll"
            style="width: 100%;"
            ref="draggableTable"
            :height="isActive ? 'calc(100vh - 470px)' : 'calc(100vh - 300px)'"
        >
          <template #handle="scope">
              <el-button class="list-btn-four btn-blue" @click="toOrderDetail(scope.row)">详情</el-button>
              <el-button v-if="showEditBtn(scope.row.orderStatus)" class="list-btn-four btn-deepblue" @click="toEditOrder(scope.row)">编辑</el-button>
              <el-button v-if="showSplitOrderBtn(scope.row)" class="list-btn-four btn-deepblue" @click="splitOrder(scope.row)">
                拆单</el-button>
              <!-- <el-button
                v-if="showBill(scope.row.orderStatus)"
                class="list-btn-four btn-blue"
                @click="addBill(scope.row)"
              >账单</el-button> -->
              <!-- <el-button
                v-if="showSendBill(scope.row.orderStatus)"
                class="list-btn-four btn-red"
                @click="addSendBill(scope.row)"
              >发送账单</el-button> -->
              <el-button class="list-btn-four btn-blue" @click="remind(scope.row)">
                提醒
              </el-button>
            <el-button
                class="list-btn-four btn-blue"
                @click="create1688Order(scope.row)"
                v-show="scope.row.orderStatus == 1 && scope.row?.taobaoUrl.includes('1688')"
            >
              1688下单
            </el-button>
              <el-button
                  class="list-btn-four btn-blue"
                  @click="handleOrderTb(scope.row)"
                  v-show="scope.row.orderStatus == 1 && (scope.row?.taobaoUrl.includes('taobao') || scope.row?.taobaoUrl.includes('tmall'))"
              >
                淘宝下单
              </el-button>
              <el-button class="list-btn-four btn-blue" @click="buyout(scope.row)" v-show="scope.row.orderStatus == 1">
                购买完
              </el-button>
              <el-button class="list-btn-four btn-blue" @click="cancelPurchaseStatus(scope.row)" v-show="scope.row.orderStatus == 2 ||
                  (scope.row.orderStatus == 0 && scope.row.agentFlag == 1)
                  ">
                取消购买完
              </el-button>
              <el-button class="list-btn-four btn-blue" @click="cancelCheckIn(scope.row)" v-show="scope.row.orderStatus == 4">
                取消收货
              </el-button>
              <el-button class="list-btn-four btn-blue" @click="cancelCheck(scope.row)" v-show="scope.row.orderStatus == 88 || scope.row.orderStatus == 8
                  ">
                取消检品
              </el-button>
              <el-button class="list-btn-four btn-blue" @click="Store(scope.row)" v-show="scope.row.orderStatus == 2">
                店铺发货
              </el-button>
              <el-button class="list-btn-four btn-blue" @click="cantBuy(scope.row)" v-show="scope.row.orderStatus == 1">
                无法购买
              </el-button>
              <el-button class="list-btn-four btn-blue" @click="returned(scope.row)" v-show="scope.row.orderStatus == 0 || scope.row.orderStatus == 2
                  ">
                退货
              </el-button>
<!--              <el-button class="list-btn-four btn-red" v-if="scope.row.orderStatus == 0 ||
                  scope.row.orderStatus == 1 ||
                  scope.row.orderStatus == 2
                  " @click="arrivalRemind(scope.row)">到货提醒</el-button>-->
          </template>
          <template #checkReport="scope">
              <span v-if="!scope.row.checkReport"> 生成中 </span>
              <div v-else>
                <span>已生成</span>
                <div><el-button class="list-btn btn-blue" @click="checkReportView(scope.row.checkReport)">
                  查看
                </el-button>
                </div>
                <div><el-button class="list-btn btn-blue" @click="checkReportDownload(scope.row.checkReport)">
                  下载</el-button></div>
              </div>
          </template>
          <!-- 订单编号 -->
          <template #splitOrderId="scope">
            <div>
              <span>{{ scope.row.clientMasterUserName }}</span>
            </div>
            <div>
              <span>{{ scope.row.id }}</span>
            </div>
            <div v-if="scope.row.splitOrderId">
              <font color="#0082FF" @click="
                    $router.push({
                      name: 'orderDetail',
                      query: { id: scope.row.splitOrderId, isEdit: '0' },
                    })
                    " style="cursor: pointer">{{ scope.row.splitOrderId }}-{{ scope.row.splitSeq }}</font>
            </div>
            <div v-if="scope.row.orderGroupTitle">
              <span>{{ scope.row.orderGroupTitle }}</span>
            </div>
            <div v-if="(scope.row.orderGroupId == 0 || scope.row.orderGroupId == null) && scope.row.orderStatus == 1">
              <el-link type="primary" style="margin-left: 5px;" @click="updateOrderGroup([scope.row.orderId])" :underline="false">分组</el-link>
            </div>
          </template>
          <!-- 工作签 -->
          <template #staffRemark="scope">
            <el-input type="textarea" @change="quickSave(scope.row.staffRemark, '5', scope.row.id)" placeholder="请输入采购内容" v-model="scope.row.staffRemark"
                      size="small">
            </el-input>
            <el-input style="padding-top: 5px" type="textarea" @change="quickSave(scope.row.checkRemark, '6', scope.row.id)" placeholder="请输入检品内容"
                      v-model="scope.row.checkRemark" size="small">
            </el-input>
          </template>
          <!-- PDF文件/检品文件 -->
          <template #pdfUrl="scope">
            <my-upload :key="Math.random()" v-model="scope.row.pdfAttachment" disabled size="mini" isJson isDelInfo mode="array" :keyObject="{ url: 'url', name: 'name' }"
                       :limit="5" listType="text">
            </my-upload>

            <my-upload :key="Math.random()" style="border-top:1px solid #ccc" disabled size="mini" v-model="scope.row.inspectionFileUrl"
                       :fileName="scope.row.inspectionFileName" :limit="1" listType="text">
            </my-upload>
            <!-- <div
              class="can-click"
              @click="downloadPdf(scope.row.pdfName, scope.row.pdfUrl)"
            >
              {{ scope.row.pdfName }}
            </div> -->
            <!-- <div class="can-click" @click="
              downloadPdf(
                scope.row.inspectionFileName,
                scope.row.inspectionFileUrl
              )
              ">
              {{ scope.row.inspectionFileName }}
            </div> -->
          </template>
          <!-- 检品报告书 -->
          <!-- 产品描述 -->
          <template #productDesc="scope">
            <el-input type="textarea" @change="quickSave(scope.row.productDesc, '0', scope.row.id)" placeholder="请输入中文产品描述" v-model="scope.row.productDesc"
                      size="small">
            </el-input>
            <el-input style="padding-top: 5px" type="textarea" @change="
                  quickSave(scope.row.productDescEn, '7', scope.row.id)
                  " placeholder="请输入英文产品描述" v-model="scope.row.productDescEn" size="small">
            </el-input>
          </template>
          <template #material="scope">
            <el-input type="textarea" @change="quickSave(scope.row.materialZh, '10', scope.row.id)" placeholder="请输入中文材质" maxlength="100"  v-model="scope.row.materialZh"
                      size="small">
            </el-input>
            <el-input style="padding-top: 5px" type="textarea" @change="
                  quickSave(scope.row.materialEn, '11', scope.row.id)
                  " placeholder="请输入英文材质" maxlength="100" v-model="scope.row.materialEn" size="small">
            </el-input>
          </template>
          <template #purpose="scope">
            <el-input type="textarea" @change="quickSave(scope.row.purposeZh, '12', scope.row.id)" maxlength="100"  placeholder="请输入中文用途" v-model="scope.row.purposeZh"
                      size="small">
            </el-input>
            <el-input style="padding-top: 5px"  maxlength="100" type="textarea"  @change="
                  quickSave(scope.row.purposeEn, '13', scope.row.id)
                  " placeholder="请输入英文用途" v-model="scope.row.purposeEn" size="small">
            </el-input>
          </template>
          <!-- 中国运费 -->
          <template #chineseFreightFee="scope">
            <el-input @blur="
                  quickSave(scope.row.chineseFreightFee, '1', scope.row.id)
                  " v-model="scope.row.chineseFreightFee" type="tel" :maxlength="12"
                      oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"></el-input>
          </template>
          <!-- 单价 -->
          <template #price="scope">
            <el-input placeholder="单价" :disabled="scope.row.orderStatus != 1" @blur="quickSave(scope.row.price, '2', scope.row.id)"
                      v-model="scope.row.price" type="tel" :maxlength="12" oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
            <el-input v-if="isShowPrice != '1'" placeholder="实际购买价格"  v-model="scope.row.actualPrice" type="tel" :maxlength="10" oninput="value=value.replace(/[^\d.]/g,'')"
                      @blur="handelPrice(scope.row)"></el-input>
            <el-input v-if="isShowPrice != '1'" placeholder="历史最低价" readonly v-model="scope.row.historyPrice" type="tel" :maxlength="10"
                      oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
          </template>
          <template #sumPrice="scope">
            {{ getPrice(scope.row.price, scope.row.goodsCount) }}
          </template>
          <!-- 用户备注 -->
          <template #customerRemark="scope">
            <div v-if="scope.row.editTime" class="mark">
              编辑:{{ scope.row.editTime | dateFormatToSecond }}
              <i @click="handleCloseMark(scope.row.id, scope.$index)" class="el-icon-close"></i>
            </div>
            <el-input type="textarea" placeholder="" v-model="scope.row.customerRemark" size="small" disabled>
            </el-input>
          </template>
          <!-- 购买信息 -->
          <template #buyInfo="scope">
            <!-- 购买账号 -->
            <el-select v-model="scope.row.buyAccountId" @change="quickSave(scope.row.buyAccountId, '4', scope.row.id)" placeholder="购买账号" size="small"
                       clearable  style="margin-bottom: 10px;">
              <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id">
              </el-option>
            </el-select>
            <!-- 购买订单号 -->
            <el-input
                maxlength="50"
                @blur="quickSave(scope.row.buyOrderNumber, '3', scope.row.id, true)"
                v-model="scope.row.buyOrderNumber"
                :disabled="scope.row.orderStatus != 1 && scope.row.orderStatus != 2"
                style="margin-bottom: 10px;"
                placeholder="购买订单号">
            </el-input>
            <!-- 国内物流 -->
            <el-input maxlength="50" @blur="
                  trackingNumberChange(
                    scope.row.trackingNumberCn,
                    scope.row.id
                  )
                  " v-model="scope.row.trackingNumberCn"
                      placeholder="国内物流"></el-input>
            <div class="overflowDot" :title="scope.row.cnLogisticsStatus">
              {{ scope.row.cnLogisticsStatus }}
            </div>
            <div v-if="scope.row.arrivalTime">
              <span>到库日:</span> <br />{{ scope.row.arrivalTime }}
            </div>
          </template>
          <!-- 检品系数 -->
          <template #checkCoefficient="scope">
            <el-input placeholder="0.2~5.0之间" :disabled="scope.row.orderStatus != 1" oninput="
                                if (value > 5 || value < 0){
                                  value = ''
                                }else{
                                  this.value=this.value.replace(/\D*(\d*)(\.?)(\d{0,1})\d*/,'$1$2$3') // 只能输入数字、小数点限制1位
                                  .replace(/^0+(\d)/, '$1') // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
                                  .replace(/^\./, '0.') // 如果输入的第一位为小数点，则替换成 0. 实现自动补全
                                  .match(/^\d*(\.?\d{0,1})/g)[0] || '' // 数字开头、小数点1位
                                 }" @blur="quickSave($event.target.value, '9', scope.row.id)" v-model="scope.row.checkCoefficient"></el-input>
          </template>
          <!-- 订单状态 -->
          <template #orderStatus="scope">
            {{ scope.row.orderStatus | orderStatusFilter }}
            <el-link type="primary" v-if="scope.row.orderStatus == 88 && isManage()" style="margin-left: 5px;" @click="updateOrderStatus(scope.row,['52'])" :underline="false">修改</el-link>
            <el-link type="primary" v-if="scope.row.orderStatus == 0 && isManage()" style="margin-left: 5px;" @click="updateOrderStatus(scope.row,['2'])" :underline="false">修改</el-link>
          </template>
          <!-- 是否为FBA -->
          <template #isFBA="scope">
            {{ scope.row.orderType | ordertypeFilter }}
            <div v-if="scope.row.orderType == 0">
              <span style="margin-right: 10px">FNSKU:</span>{{ scope.row.fnsku }}
            </div>
            <div v-if="scope.row.orderType == 2 || scope.row.orderType == 5">
              <span style="margin-right: 10px">検品コード※商品バーコード情報:</span>{{ scope.row.fnsku }}
            </div>
            <div v-if="scope.row.orderType == 3">
              <span style="margin-right: 10px">ZOZOバーコード:</span>{{ scope.row.fnsku }}
            </div>
            <div v-if="scope.row.orderType == 4">
              <span style="margin-right: 10px">RSLバーコード:</span>{{ scope.row.fnsku }}
            </div>
            <div>
              <span v-if="scope.row.orderType == 0 || scope.row.orderType == 2 || scope.row.orderType == 3 || scope.row.orderType == 4 || scope.row.orderType == 5" style="margin-right: 10px">品名:{{ scope.row.goodsNameCus }}</span>
            </div>
            <div v-if="scope.row.orderType == 0">
              <span style="margin-right: 10px">ASIN:</span>{{ scope.row.asin }}
            </div>
          </template>
          <!-- 商品数量 -->
          <template #goodsCount="scope">
            <div class="all">
              <p class="item">总数量：</p>
              <span>{{ scope.row.goodsCount }}</span>
            </div>
            <div class="set-number">
              <div>
                <p class="w60">已装箱：</p>
                <span>{{ scope.row.boxedGoodsCount }}</span>
              </div>
              <div>
                <p class="w60">待装箱：</p>
                <span>{{ scope.row.waitBoxCount }}</span>
              </div>
              <div>
                <p class="w60">退货：</p>
                <span>{{ scope.row.refundCount }}</span>
              </div>
              <div>
                <p class="w60">销毁：</p>
                <span>{{ scope.row.destroyCount }}</span>
              </div>
              <div>
                <p class="w60">可装箱：</p>
                <span>{{ scope.row.canBoxCount }}</span>
              </div>
              <div>
                <p class="w60">已发送：</p>
                <span>{{ scope.row.sendCount }}</span>
              </div>
            </div>
          </template>
          <!-- 检品 -->
          <template #inspection="scope">
            <div v-for="item in scope.row.inspection.split(',').slice(0, 4)" :key="item">
              {{ item }}
            </div>
            <div v-if="scope.row.inspection && scope.row.inspection.split(',').length > 4">
              <el-tooltip placement="bottom" effect="light">
                <template #content>
                  <div style="text-align: left" v-for="item in scope.row.inspection.split(',')" :key="item">
                    {{ item }}
                  </div>
                </template>
                <div style="cursor: pointer">...</div>
              </el-tooltip>
            </div>
<!--                <span v-if="scope.row.inspection && scope.row.inspection.length > 0">
                  <div v-for="item in scope.row.inspection.split(',')" :key="item">
                    {{ item }}
                  </div>
                </span>-->
          </template>
          <!-- 仓库保管 -->
          <template #categoryFlag="scope">
            <div>
                  <span
                      v-if="scope.row.warehouseStorageDays != null && scope.row.orderStatus != '52' && scope.row.orderStatus != '72' && scope.row.orderStatus != '84' && scope.row.checkFinishTime != null">
                    <span v-if="scope.row.warehouseStorageDays >= 10">
                      免费保管中：剩余{{scope.row.warehouseStorageDays }}天
                    </span>
                    <span v-if="scope.row.warehouseStorageDays < 10 && scope.row.warehouseStorageDays > 0" style="color: orange">
                      免费保管中：剩余{{scope.row.warehouseStorageDays}}天
                    </span>
                    <span v-if="scope.row.warehouseStorageDays == 0" style="color: red">
                      免费保管中：剩余{{scope.row.warehouseStorageDays}}天
                    </span>
                    <div v-if="freeStorageDurationSettingManage()"><el-button class="list-btn btn-blue" @click="freeStorageDurationSetting(scope.row)">延迟保管时长(天)</el-button></div>
                  </span>
              <span v-else-if="
                      scope.row.chargingDays > 0 &&
                      scope.row.orderStatus != '52' &&
                      scope.row.orderStatus != '72' &&
                      scope.row.orderStatus != '84' &&
                      scope.row.categoryPrice != 0 &&
                      scope.row.freeWarehousing == '0'
                    ">保管费用：{{ scope.row.categoryPrice }}元(已保管{{
                  scope.row.chargingDays
                }}天)
                <div v-if="freeStorageDurationSettingManage()"><el-button class="list-btn btn-blue" @click="freeStorageDurationSetting(scope.row)">延迟保管时长(天)</el-button></div>
              </span>
              <span v-else></span>
            </div>
            <div>
              <el-button v-if="
                      scope.row.chargingDays > 0 &&
                      scope.row.orderStatus != '52' &&
                      scope.row.categoryPrice != 0 &&
                      scope.row.freeWarehousing == '0' &&
                      getAuthFreeStorageFee()
                    " class="list-btn-four btn-blue" @click="freeStorageFee(scope.row)">免仓储费</el-button>
            </div>
          </template>
          <!-- 包装意向 -->
          <template #putIntent="scope">
            {{ scope.row.putIntent | putIntentFilter }}
          </template>
          <!-- 代为购买 -->
          <template #agentFlag="scope">
            {{ scope.row.agentFlag | isornotFilter }}
          </template>
          <!-- 创建时间 -->
          <template #createTime="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
          <!-- 商品信息 -->
          <template #goodsInfo="scope" class="flex-column align-start">
            <div class="font-style">
              <span class="left">颜色</span>
              <span>：</span>
              <span class="right">{{ scope.row.colour }}</span>
            </div>
            <div class="font-style">
              <span class="left">尺寸</span>
              <span>：</span>
              <span class="right">{{ scope.row.goodsSize }}</span>
            </div>
            <div class="font-style">
              <span class="left">商品SKU</span>
              <span>：</span>
              <span class="right">{{ scope.row.goodsNumber }}</span>
            </div>
            <div class="font-style">
              <span class="left">商品编码</span>
              <span>：</span>
              <span class="right">{{ scope.row.goodsCode }}</span>
            </div>
          </template>
          <!-- 图片 -->
          <template #picture="scope">
            <img @paste="onPasteUpload" @click="imgclick(scope.row, scope.$index)" v-if="scope.row.pictureUrl && scope.row.pictureUrl.length > 0"
                 :src="scope.row.pictureUrl" alt="" class="list-image" />
            <img v-else @click="imgclick(scope.row, scope.$index)" src="@/assets/images/default.png" alt="" class="list-image" />
            <div class="btn-row">
              <el-button class="list-btn-four btn-blue" @click="toGoodsDetail(scope.row)">
                商品详情
              </el-button>
            </div>
          </template>
          <!-- 不良待处理 -->
          <template #badCount="scope">
            <div class="font-style1">
              <span class="left">不良待处理</span>
              <span>：</span>
              <span class="right">{{ scope.row.badCount }}</span>
            </div>
            <div class="font-style1">
              <span class="left">换货中</span>
              <span>：</span>
              <span class="right">{{ scope.row.exchangCount }}</span>
            </div>
            <div class="font-style1">
              <span class="left">补发中</span>
              <span>：</span>
              <span class="right">{{ scope.row.reissueCount }}</span>
            </div>
          </template>
          <!-- 用户ID -->
          <template #userName="scope">
            <div style="text-align: left">
              <div>
                <span>{{ scope.row.userName }}</span>
              </div>
              <div>
                <span>{{ scope.row.realName }}</span>
              </div>
              <div v-if="scope.row.clientManagerUserName">
                <el-tooltip :content="'负责人:'+scope.row.clientManagerUserName" placement="top" effect="light">
                  <span class="text-row-1" style="color: #ff0000">负责人:{{ scope.row.clientManagerUserName }}</span>
                </el-tooltip>
              </div>
            </div>
          </template>
        </draggable-table>
<!--        <el-table :data="orderList" :header-cell-style="tableStyle.headerStyle" v-loading="isLoading" border stripe style="width: 100%" @select="tableSelect"-->
<!--          @select-all="tableSelectAll" height="550">-->
<!--        &lt;!&ndash; <el-table :data="orderList" :header-cell-style="tableStyle.headerStyle" v-loading="isLoading" border stripe style="width: 100%" height="550"> &ndash;&gt;-->
<!--          <el-table-column type="index" label="" width="25" fixed="left" align="center"></el-table-column>-->
<!--          <el-table-column  type="selection" fixed="left" align="center" width="25"></el-table-column>-->
<!--            &lt;!&ndash; <template v-slot="scope"> &ndash;&gt;-->
<!--              &lt;!&ndash; <div style="margin-right: 0">{{ scope.$index + 1 }}</div> &ndash;&gt;-->
<!--              &lt;!&ndash; <el-checkbox v-model="scope.row.isSelected" @change="(val) => tableSelect(val, scope.row)"></el-checkbox> &ndash;&gt;-->
<!--              &lt;!&ndash; <el-checkbox :value="ids.includes(scope.row.id)"  @change="tableSelect($event, scope.row)"></el-checkbox> &ndash;&gt;-->
<!--            &lt;!&ndash; </template> &ndash;&gt;-->
<!--          &lt;!&ndash; </el-table-column> &ndash;&gt;-->
<!--          <el-table-column v-for="(item, index) in asyncColumns" :key="index" align="center" :label="item.name" :prop="item.key"-->
<!--            :width="item.width ? item.width : 'auto'" :min-width="item.minWidth ? item.minWidth : 'auto'">-->
<!--            <template v-slot="scope">-->
<!--              &lt;!&ndash; 操作 &ndash;&gt;-->
<!--              <div v-if="item.key === 'handle'">-->
<!--                <el-button class="list-btn-four btn-blue" @click="toOrderDetail(scope.row)">详情</el-button>-->
<!--                <el-button v-if="showEditBtn(scope.row.orderStatus)" class="list-btn-four btn-deepblue" @click="toEditOrder(scope.row)">编辑</el-button>-->
<!--                <el-button v-if="showSplitOrderBtn(scope.row)" class="list-btn-four btn-deepblue" @click="splitOrder(scope.row)">-->
<!--                  拆单</el-button>-->
<!--                &lt;!&ndash; <el-button-->
<!--                  v-if="showBill(scope.row.orderStatus)"-->
<!--                  class="list-btn-four btn-blue"-->
<!--                  @click="addBill(scope.row)"-->
<!--                >账单</el-button> &ndash;&gt;-->
<!--                &lt;!&ndash; <el-button-->
<!--                  v-if="showSendBill(scope.row.orderStatus)"-->
<!--                  class="list-btn-four btn-red"-->
<!--                  @click="addSendBill(scope.row)"-->
<!--                >发送账单</el-button> &ndash;&gt;-->
<!--                <el-button class="list-btn-four btn-blue" @click="remind(scope.row)">-->
<!--                  提醒-->
<!--                </el-button>-->
<!--                <el-button-->
<!--                    class="list-btn-four btn-blue"-->
<!--                    @click="handleOrder(scope.row, '1688')"-->
<!--                    v-show="scope.row.orderStatus == 1 && scope.row?.taobaoUrl.includes('1688')"-->
<!--                >-->
<!--                  1688下单-->
<!--                </el-button>-->
<!--                <el-button-->
<!--                    class="list-btn-four btn-blue"-->
<!--                    @click="handleOrderTb(scope.row)"-->
<!--                    v-show="scope.row.orderStatus == 1 && (scope.row?.taobaoUrl.includes('taobao') || scope.row?.taobaoUrl.includes('tmall'))"-->
<!--                >-->
<!--                  淘宝下单-->
<!--                </el-button>-->
<!--                <el-button class="list-btn-four btn-blue" @click="buyout(scope.row)" v-show="scope.row.orderStatus == 1">-->
<!--                  购买完-->
<!--                </el-button>-->
<!--                <el-button class="list-btn-four btn-blue" @click="cancelPurchaseStatus(scope.row)" v-show="scope.row.orderStatus == 2 ||-->
<!--                  (scope.row.orderStatus == 0 && scope.row.agentFlag == 1)-->
<!--                  ">-->
<!--                  取消购买完-->
<!--                </el-button>-->
<!--                <el-button class="list-btn-four btn-blue" @click="cancelCheckIn(scope.row)" v-show="scope.row.orderStatus == 4">-->
<!--                  取消收货-->
<!--                </el-button>-->
<!--                <el-button class="list-btn-four btn-blue" @click="cancelCheck(scope.row)" v-show="scope.row.orderStatus == 88 || scope.row.orderStatus == 8-->
<!--                  ">-->
<!--                  取消检品-->
<!--                </el-button>-->
<!--                <el-button class="list-btn-four btn-blue" @click="Store(scope.row)" v-show="scope.row.orderStatus == 2">-->
<!--                  店铺发货-->
<!--                </el-button>-->
<!--                <el-button class="list-btn-four btn-blue" @click="cantBuy(scope.row)" v-show="scope.row.orderStatus == 1">-->
<!--                  无法购买-->
<!--                </el-button>-->
<!--                <el-button class="list-btn-four btn-blue" @click="returned(scope.row)" v-show="scope.row.orderStatus == 0 || scope.row.orderStatus == 2-->
<!--                  ">-->
<!--                  退货-->
<!--                </el-button>-->
<!--                <el-button class="list-btn-four btn-red" v-if="scope.row.orderStatus == 0 ||-->
<!--                  scope.row.orderStatus == 1 ||-->
<!--                  scope.row.orderStatus == 2-->
<!--                  " @click="arrivalRemind(scope.row)">到货提醒</el-button>-->
<!--              </div>-->
<!--              &lt;!&ndash; 检品报告 &ndash;&gt;-->
<!--              <div v-if="item.key === 'checkReport'">-->
<!--                <span v-if="!scope.row.checkReport"> 生成中 </span>-->
<!--                <div v-else>-->
<!--                  <span>已生成</span>-->
<!--                  <div><el-button class="list-btn btn-blue" @click="checkReportView(scope.row.checkReport)">-->
<!--                      查看-->
<!--                    </el-button>-->
<!--                  </div>-->
<!--                  <div><el-button class="list-btn btn-blue" @click="checkReportDownload(scope.row.checkReport)">-->
<!--                      下载</el-button></div>-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash; 其他不需要处理的 &ndash;&gt;-->
<!--              <span v-else>-->
<!--                {{ scope.row[item.key] }}-->
<!--              </span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 拆单 -->
    <el-dialog title="拆单" :visible.sync="splitDialogVisible" width="90%" @close="splitDialogClosed">
      <el-row>
        <el-col :span="12" class="split-col">
          <el-form label-width="120px" class="demo-ruleForm">
            <div class="split-title">原订单信息：</div>
            <div>
              <el-form-item label="原订单编号：">
                <el-input v-model="orginSplitOrderInfo.id" disabled></el-input>
              </el-form-item>
              <el-form-item label="订单状态">
                <!-- <el-select v-model="orginSplitOrderInfo.orderStatus" placeholder="请选择" size="small" disabled>
                  <el-option v-for="(item,index) in orderStatusOptions" :key="index" :value="item.value" :label="item.label">
                  </el-option>
                </el-select> -->
                <div>
                  {{ orginSplitOrderInfo.orderStatus | orderStatusFilter }}
                </div>
              </el-form-item>
              <el-form-item label="数量">
                <el-input v-model="orginSplitOrderInfo.goodsCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="退货数">
                <el-input v-model="orginSplitOrderInfo.refundCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="销毁数">
                <el-input v-model="orginSplitOrderInfo.destroyCount" disabled></el-input>
              </el-form-item>
              <el-form-item label="FBA/YFF/ZOZO/RSL/STOCKCREW">
                <el-select v-model="orginSplitOrderInfo.orderType" placeholder="请选择" size="small" disabled>
                  <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库保管">
                <el-select v-model="orginSplitOrderInfo.categoryFlag" placeholder="请选择" size="small" disabled>
                  <el-option key="1" value="1" label="是"></el-option>
                  <el-option key="0" value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
        <el-col :span="12" class="split-col">
          <el-form :model="splitOrderInfo" label-width="120px" class="split-form" :rules="splitFormRules" ref="splitOrderInfo">
            <div class="split-title">拆出订单信息：</div>
            <div>
              <el-form-item label="订单状态">
                <!-- <el-select v-model="splitOrderInfo.orderStatus" placeholder="请选择" size="small" disabled>
                  <el-option v-for="(item,index) in orderStatusOptions" :key="index" :value="item.value" :label="item.label">
                  </el-option>
                </el-select> -->
                <div>{{ splitOrderInfo.orderStatus | orderStatusFilter }}</div>
              </el-form-item>
              <el-form-item label="FBA/YFF/ZOZO/RSL/STOCKCREW">
                <el-select v-model="splitOrderInfo.orderType" placeholder="请选择" size="small" disabled>
                  <el-option v-for="item in fbaOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="仓库保管">
                <el-select v-model="splitOrderInfo.categoryFlag" placeholder="请选择" size="small" disabled>
                  <el-option key="1" value="1" label="是"></el-option>
                  <el-option key="0" value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数量" prop="goodsCount">
                <el-input v-model="splitOrderInfo.goodsCount"></el-input>
              </el-form-item>
              <el-form-item label="退货数" prop="refundCount">
                <el-input v-model="splitOrderInfo.refundCount"></el-input>
              </el-form-item>
              <el-form-item label="销毁数" prop="destroyCount">
                <el-input v-model="splitOrderInfo.destroyCount"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="splitDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="splitSave('splitOrderInfo')">提 交</el-button>
      </span>
    </el-dialog>

    <!--    图片放大-->
    <el-dialog title="" :visible.sync="bigvisible" width="30%" :show-close="false" :close-on-click-modal="false" center>
      <!--      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">-->
      <el-upload class="editor-slide-upload bigimg" action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj" :multiple="false" ref="uploads"
        :file-list="replyInfo.imgFileList" :show-file-list="true" list-type="picture-card" :on-remove="handleImgRemove2" :on-success="handleImgSuccess2"
        accept="image/png,image/jpeg" :before-upload="beforeImgUpload" :limit="1">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>

      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="imgDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="imgSave('replyInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <!--    购买完-->
    <el-dialog title="" :visible.sync="buyoutvisible" width="40%" show-close :destroy-on-close="true" @close="buyoutDialogClose" center>
      <el-form :model="buyoutInfo" :rules="buyoutrules" ref="buyoutInfo" label-width="120px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item style="margin-bottom: 15px !important" label="用户ID:">
          <span>{{ buyoutInfoonreade.userName }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px !important" label="订单编号:">
          <div style="display: inline-block">
            <span>{{ buyoutInfoonreade.id }}</span>
          </div>
          <div style="display: inline-block; margin-left: 20px" v-if="buyoutInfoonreade.splitOrderId">
            <font color="#0082FF">{{ buyoutInfoonreade.splitOrderId }}-{{
                buyoutInfoonreade.splitSeq
              }}</font>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 20px !important" label="单价:" prop="price">
          <el-input-number :disabled="orginSplitOrderInfo.orderStatus != 1" v-model="buyoutInfo.price" controls-position="right" :precision="2" :min="0"
            style="width: 350px">
          </el-input-number>
          &emsp;
          <span>历史最低价: {{ buyoutInfoonreade.historyPrice }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 20px !important" label="数量:" prop="goodsCount">
          <el-input-number v-model="buyoutInfo.goodsCount" controls-position="right" :precision="0" :min="0" style="width: 350px">
          </el-input-number>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="购买订单号:" prop="buyOrderNumber">
          <el-input @blur="
            optionchange(buyoutInfo.buyOrderNumber, 'ddh', buyoutInfo.orderId)
            " maxlength="50" v-model.trim="buyoutInfo.buyOrderNumber"></el-input>
        </el-form-item>
        <el-form-item label="购买账号:" prop="buyAccountId">
          <!--          <el-input v-model="buyoutInfo.buyAccountId"></el-input>-->
          <el-select v-model.trim="buyoutInfo.buyAccountId" @change="
            optionchange(buyoutInfo.buyAccountId, 'zh', buyoutInfo.orderId)
            " placeholder="请选择" size="small" clearable>
            <el-option v-for="item in buyAcountList" :key="item.id" :label="item.platformType_hanzi" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 20px !important" label="中国运费:" prop="chineseFreightFee">
          <el-input-number v-model="buyoutInfo.chineseFreightFee" controls-position="right" :precision="2" :min="0" style="width: 350px"></el-input-number>
        </el-form-item>
        <el-form-item label="检品系数:" prop="checkCoefficient">
          <el-input placeholder="0.2~5.0之间" v-model="buyoutInfo.checkCoefficient"></el-input>
        </el-form-item>
        <el-form-item label="中国物流公司:">
          <el-select v-model="buyoutInfo.cnLogisticsCompanyId" @change="updateSelect" placeholder="请选择" size="small" clearable>
            <el-option v-for="item in dropDownList" :key="item.id" :label="item.companyName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中国运单号:" prop="trackingNumberCn">
          <el-input maxlength="50" v-model="buyoutInfo.trackingNumberCn"></el-input>
        </el-form-item>
        <el-form-item label="免费仓储:" prop="freeWarehousing">
          <el-select v-model="buyoutInfo.freeWarehousing" placeholder="请选择" size="small" clearable>
            <el-option key="1" value="1" label="是"></el-option>
            <el-option key="0" value="0" label="否" selected></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <p style="text-align: center">
          如果您输入了中国运单号，则订单将直接变为等待到库
        </p>
        <el-button class="form-btn btn-gray" @click="buyoutDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="buyoutSave('buyoutInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <!--    店铺发货-->
    <el-dialog title="" :visible.sync="Storevisible" width="40%" show-close @close="StoreDialogClose" center>
      <el-form :model="StoreInfo" :rules="Storerules" ref="StoreInfo" label-width="120px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item style="margin-bottom: 15px !important" label="用户ID：">
          <span>{{ buyoutInfoonreade.userName }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px !important" label="订单编号：">
          <div style="display: inline-block">
            <span>{{ buyoutInfoonreade.id }}</span>
          </div>
          <div style="display: inline-block; margin-left: 20px" v-if="buyoutInfoonreade.splitOrderId">
            <font color="#0082FF">{{ buyoutInfoonreade.splitOrderId }}-{{
                buyoutInfoonreade.splitSeq
              }}</font>
          </div>
        </el-form-item>
        <!-- 内容 -->
        <!-- <el-form-item label="国内运费(元)：">
          <el-input v-model="StoreInfo.inlandFreight"></el-input>
        </el-form-item> -->
        <el-form-item label="物流公司:" prop="cnLogisticsCompanyId">
          <el-select v-model="StoreInfo.cnLogisticsCompanyId" placeholder="请选择" size="small" clearable>
            <el-option v-for="item in dropDownList" :key="item.id" :label="item.companyName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国内运单号:" prop="trackingNumberCn">
          <el-input maxlength="50" v-model="StoreInfo.trackingNumberCn"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="StoreDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="StoreSave('StoreInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <!--  退货  -->
    <el-dialog title="退货" :visible.sync="returnedvisible" width="40%" show-close @close="ReturnedDialogClose" center>
      <el-form :model="returnedInfo" ref="returnedInfo" label-width="120px" class="demo-replyInfo">
        <!-- 只读 -->
        <el-form-item style="margin-bottom: 15px !important" label="用户ID：">
          <span>{{ buyoutInfoonreade.userName }}</span>
        </el-form-item>
        <el-form-item style="margin-bottom: 15px !important" label="订单编号：">
          <div style="display: inline-block">
            <span>{{ buyoutInfoonreade.id }}</span>
          </div>
          <!-- <div
            style="display: inline-block;margin-left: 20px"
            v-if="buyoutInfoonreade.splitOrderId"
          >
            <font color="#0082FF">{{buyoutInfoonreade.splitOrderId}}-{{buyoutInfoonreade.splitSeq}}</font>
          </div> -->
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="退货运费(元)：">
          <el-input v-model="returnedInfo.returnFee"></el-input>
        </el-form-item>
        <el-form-item label="退货手续费(元)：">
          <el-input v-model="returnedInfo.refundServiceFee"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="ReturnedDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="ReturnedSave('returnedInfo')">提 交</el-button>
      </div>
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>
    <!-- <MessageTip :visiable.sync="isVisiable" :userName="replyMessageInfo.userName" messageType="订单消息"
                :orderNo="replyMessageInfo.id" httpUrl="cms/inBox/reply" @confirm="onConfirmMsg"></MessageTip> -->
    <MessageTip :visiable.sync="isVisiable" :info="replyMessageInfo" @confirm="onConfirmMsg"></MessageTip>
    <el-dialog title="批量购买账号" :visible.sync="accountDialogVisible" width="50%">
      <p class="dialog-account">
        <el-radio v-for="item in buyAcountList" :key="item.id" v-model="batchAccount.buyAccountId" :label="item.id">{{
            item.id }}{{ item.platformType_hanzi }}</el-radio>
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button @click="accountDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchUpdateAccount()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="title" :visible.sync="arrivalRemindDialogVisible" :close-on-click-modal="false" width="50%">
      <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="100px" class="messageTip">
        <!-- 只读 -->
        <div class="lx-flex-row">
          <el-form-item label="订单编号:">
            <span>{{ arrivalRemindInfo.orderId }}</span>
          </el-form-item>
        </div>
        <el-form-item label="内容:" prop="remindingContent">
          <quill-editor ref="text" v-model="arrivalRemindInfo.arrivalRemindContent" :options="editorOption" />
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button class="form-btn btn-gray" @click="arrivalRemindDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="submitArrivalRemind">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="pdfViewDialogVisible" :close-on-click-modal="false" width="100%">

      <iframe  id="pdfIframe" @load="adjustIframe" :src="pdfurl"
               type="application/x-google-chrome-pdf"></iframe>
    </el-dialog>

    <el-dialog title="修改免费保管时长" :visible.sync="freeStorageDurationDialogVisible" width="50%">
      <el-form :model="freeStorageDurationInfo" :rules="freeStorageDurationInfoRules" ref="freeStorageDurationInfo" label-width="120px" class="demo-replyInfo">
        <el-form-item label="保管时长(天)：" prop="duration" class="freeStorageDurationInfo">
          <el-input style="width: 100px" disabled v-model="freeStorageDurationInfo.freeStorageDuration"></el-input>
          +
          <el-input style="width: 200px" type="number" v-model="freeStorageDurationInfo.duration"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="freeStorageDurationDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateFreeStorageDuration()">确 定</el-button>
      </span>
    </el-dialog>
    <create1688-order ref="create1688Order" />
  </div>
</template>

<script>
import { columns as originColumns } from "./ordersColumns"
import { filterList } from "@/assets/js/utils"
import LxSort from "@/components/LxSort/index"
import Oss from "../../assets/js/oss.js"
import tableCon from "../../views/tableContainer"
import MessageTip from "@/components/MessageTip/index"
import DraggableTable from "@/components/DraggableTable/index.vue"
import { CreatedUrl } from "@/class/index"
import create1688Order from './components/create1688Order'
import {fastKey} from "core-js/internals/internal-metadata";
export default {
  components: {
    LxSort,
    tableCon,
    MessageTip,
    DraggableTable,
    create1688Order
  },
  name: "orders",
  // name: "order/Orders",
  data () {
    const validateCheckCoefficient = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入检品系数"))
        return
      }

      if (value > 5 || value < 0.2) {
        callback(new Error("检品系数不正确"))
        return
      }
      callback()
    }

    // 只允许0-1之间 保留最大4位小数
    const checkNumLength = (rule, value, callback) => {
      console.log(value)
      if (value == null) {
        return callback(new Error("不能为空"))
      } else {
        var reg = /^(0(\.\d{1,4})?|1(\.0{1,4})?)$/g
        // var reg = new RegExp('^(0(\.\d{1,4})?|1(\.0{1,4})?)$');
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error("只允许0-1之间,且最大保留4位小数"))
        }
      }
    }
    const validateOeder = (rule, value, callback) => {
      if (/^[A-Za-z0-9]+$/.test(value) || value === "") {
        callback()
      } else {
        callback(new Error("只能字母或数字的组合"))
      }
    }
    //自定义校验产品数量
    const checkGoodsCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) <= 0 ||
          parseInt(value) >= parseInt(this.orginSplitOrderInfo.goodsCount)
        ) {
          callback(new Error("数量应大于0小于原数量"))
        }
        callback()
      } else {
        callback(new Error("请输入数量"))
      }
    }
    const checkRefundCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) < 0 ||
          parseInt(value) > parseInt(this.orginSplitOrderInfo.refundCount)
        ) {
          callback(new Error("退货数应大于等于0小于等于原退货数"))
        }
        callback()
      } else {
        callback(new Error("请输入退货数"))
      }
    }
    const checkDestroyCount = (rule, value, callback) => {
      if (/^\d+$/.test(value)) {
        if (
          parseInt(value) < 0 ||
          parseInt(value) > parseInt(this.orginSplitOrderInfo.destroyCount)
        ) {
          callback(new Error("销毁数应大于等于0小于等于原销毁数"))
        }
        callback()
      } else {
        callback(new Error("请输入销毁数"))
      }
    }
    return {
      title: "",
      arrivalRemindInfo: {
        orderId: "",
        arrivalRemindContent: "",
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ["bold"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
            ],
          },
        },
      },
      arrivalRemindDialogVisible: false,
      isActive: false,
      batchAccount: {
        buyAccountId: "",
      },
      accountDialogVisible: false,
      curIndex: 0, // 默认选中第0个
      isLoading: true,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      menuSettingData: {
        menuId: "staffOrders",
      },
      accountorderlist: [],
      buyoutInfoonreade: {
        userName: "",
        orderno: "",
        price: "",
        num: "",
        id: "",
        splitOrderId: "",
        splitSeq: "",
      },
      fileList: [],
      bigvisibleimgDataObj: [],
      bigimgFileList: {},
      bigvisible: false,
      buyoutvisible: false,
      Storevisible: false,
      visible: false,
      returnedvisible: false,
      imgurl: "",
      dropDownList: [],
      queryInfo: {
        id: "",
        trackingNumberCn: "",
        trackingNumberJpn: "",
        sagawaState: "",
        orderStatus: "",
        // orderStatusList:[],
        customerName: "",
        userName: "",
        receiver: "",
        categoryFlag: "",
        createTimeStart: "",
        createTimeEnd: "",
        sendTimeStart: "",
        sendTimeEnd: "",
        orderType: "",
        whetherStorageFee: "",
        goodsCode: "",
        pageSize: 10,
        pageNum: 1,
        isCnLogisticsStatusUpdate:'',
      },
      // orderDateRangeValue:'',
      // shipDateRangeValue:[],
      sagawaStateOptions: [
        {
          value: "1",
          label: "黄金糕",
        },
        {
          value: "2",
          label: "双皮奶",
        },
        {
          value: "3",
          label: "蚵仔煎",
        },
        {
          value: "4",
          label: "龙须面",
        },
        {
          value: "5",
          label: "北京烤鸭",
        },
      ],
      orderStatusOptions: [],
      index: "",
      splitDialogVisible: false,
      orginSplitOrderInfo: {},
      splitOrderInfo: {},
      splitForm: {},
      total: 0,
      splitFormRules: {
        goodsCount: [
          { required: true, message: "请输入数量", trigger: "change" },
          { validator: checkGoodsCount },
        ],
        refundCount: [
          { required: true, message: "请输入退货数", trigger: "change" },
          { validator: checkRefundCount },
        ],
        destroyCount: [
          { required: true, message: "请输入销毁数", trigger: "change" },
          { validator: checkDestroyCount },
        ],
      },
      listObj: [],
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },

      buyoutInfo: {
        orderId: "",
        buyAccountId: "",
        cnLogisticsCompanyId: "",
        buyOrderNumber: "",
        chineseFreightFee: "",
        trackingNumberJpn: "",
        trackingNumberCn: "",
        checkCoefficient: "",
        price: "",
        goodsCount: "",
        freeWarehousing: "0",
      },
      orderlist: [],
      orderList: [],
      orderCount: {
        total: 0,
        pendingPurchaseCount: 0,
        purchasedCount: 0,
        waitWarehouseCount: 0,
        arrivalCount: 0,
        warehouseStorageCount: 0,
        waitPayCount: 0,
        badOrderCount: 0,
        finishCount: 0,
      },
      fbaOption: [
        {
          label: "否",
          value: "1",
        },
        {
          label: "FBA",
          value: "0",
        },
        {
          label: "YFF",
          value: "2",
        },
        {
          label: "ZOZO",
          value: "3",
        },
        {
          label: "RSL",
          value: "4",
        },
        {
          label: "STOCKCREW",
          value: "5",
        },
      ],
      StoreInfo: {
        orderId: "",
        inlandFreight: "",
        cnLogisticsCompanyId: "",
        trackingNumberJpn: "",
        trackingNumberCn: "",
      },
      returnedInfo: {
        orderId: "",
        refundServiceFee: 5.0,
        returnFee: 0.0,
      },
      rules: {
        remindingTitle: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        remindingContent: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
        ],
      },
      buyoutrules: {
        // buyOrderNumber: [
        //   { required: false, validator: validateOeder, trigger: "blur" },
        //   // { pattern: /^[A-Za-z0-9]+$/, message: '只能字母或数字的组合', trigger: 'blur' },
        // ],
        chineseFreightFee: [
          { required: true, message: "请输入中国运费", trigger: "blur" },
        ],
        price: [{ required: true, message: "请输入单价", trigger: "blur" }],
        goodsCount: [
          { required: true, message: "请输入数量", trigger: "blur" },
        ],
        buyOrderNumber: [
          { required: true, message: "请输入购买订单号", trigger: "blur" },
        ],
        buyAccountId: [
          { required: true, message: "请输入购买账号", trigger: "change" },
        ],
 /*       checkCoefficient: [
          {
            required: true,
            validator: validateCheckCoefficient,
            trigger: "blur",
          },
        ],*/
      },
      Storerules: {
        // configLogisticsCompanyId: [
        //   { required: true, message: '请选择物流公司', trigger: 'blur' }
        // ],
        trackingNumberCn: [
          { required: true, message: "请输入国内运单号", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "只能字母或数字的组合",
            trigger: "blur",
          },
        ],
      },
      replyMessageInfo: {},
      file: "",
      bigimglist: {
        orderId: "",
        pictureUrl: "",
        upfile: "",
      },
      buyAcountList: [],
      orderDetailList: [],
      isVisiable: false, // 消息提醒弹框
      replyInfo: {
        orderId: "",
        remindingUserName: "",
        remindingTitle: "",
        remindingTitleJa: "",
        remindingContent: "",
        url: "",
        replyPicture: "",
        imgFileList: [],
        imgFileListStr: "",
      },
      ids: [],
      pdfurl:'',
      pdfViewDialogVisible:false,
      isShowPrice: "0",
      freeStorageDurationDialogVisible: false,
      freeStorageDurationInfo: {
        orderId: "",
        freeStorageDuration: "",
        duration: "",
      },
      freeStorageDurationInfoRules : {
        duration: [
          { required: true, message: "请输入时长", trigger: "blur" },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: "只能输入正整数",
            trigger: "blur",
          },
        ],
      }
    }
  },
  created () {
    this.getOrderCount()
    this.getBuyAccountList()
    this.getAsyncColumns().then(() => {

      this.getOrderList()
      this.getAllList()
    })
  },
  activated () {
    // 从编辑页返回，刷新页面
    const route = this.$route
    if (route.query?.show) {
      this.getOrderList()
    }
  },
  methods: {
    async handleColumnDrop(event) {
      // console.log('列顺序变化:', event);
      await this.doSaveColumns(event.columns);
      await window.location.reload()
      // console.log(112233)
    },
    handleColumnClose(event) {
      // console.log('关闭列:', event);
      const list = this.asyncColumns.filter((item) => item.key !== event.column.key);
      this.doSaveColumns(list);
    },
    isManage(){
      return window.sessionStorage.getItem('role') == '普通管理员' || window.sessionStorage.getItem('role') == '超级管理员' || window.sessionStorage.getItem('role') == '超超级管理员'
    },
    freeStorageDurationSettingManage(){
      return window.sessionStorage.getItem('username') == 'admin' || window.sessionStorage.getItem('username') == 'puencg02' || window.sessionStorage.getItem('username') == 'yukiki' || window.sessionStorage.getItem('username') == 'leonora'
    },
    updateOrderStatus(row,optional){
      console.log(row)
      this.$modalDialog(() => import("./components/updateOrderStatus.vue"), {
        id: row.id,
        optional: optional,
      }).then(
          () => {
            this.getOrderList()
          },
          (res) => {
            console.log(res)
          }
      )
    },
    updateOrderGroup(orderIdList){
      console.log(orderIdList)
      this.$modalDialog(() => import("./components/updateOrderGroup.vue"), {
        orderIdList: orderIdList
      }).then(
          () => {
            this.getOrderList()
          },
          (res) => {
            console.log(res)
          }
      )
    },
    // iframe高度
    adjustIframe() {
      var ifm = document.getElementById("pdfIframe");
      ifm.height = document.documentElement.clientHeight-50;
      ifm.width = document.documentElement.clientWidth-50;
    },
    handleOrder(row, type){
      this.$modalDialog(() => import('./components/orders.vue'), {
        row,
        xdType: type
      }).then(
          () => {
            this.searchList()
          },
          () => {
          }
      )
    },
    create1688Order(row){
      this.$refs.create1688Order.show(row.customerUserId);
    },
    handleOrderTb(row){
      this.$modalDialog(() => import('./components/ordersTb.vue'), {
        row,
      }).then(
          () => {
            this.searchList()
          },
          () => {
          }
      )
    },
    freeStorageDurationSetting(row){
      this.freeStorageDurationInfo = row
      this.freeStorageDurationDialogVisible = true
    },
    updateFreeStorageDuration () {
      this.$refs['freeStorageDurationInfo'].validate(async (valid) => {
        if (valid) {
          let freeStorageDuration = {
            orderId: this.freeStorageDurationInfo.orderId,
            freeStorageDuration: Number(this.freeStorageDurationInfo.freeStorageDuration) + Number(this.freeStorageDurationInfo.duration),
          }
          // 提交数据
          this.$http
              .post("order/updateFreeStorageDuration", freeStorageDuration)
              .then(({data}) => {
                if (data.code === 200) {
                  this.freeStorageDurationDialogVisible = false
                  this.getOrderList()
                  this.$message.success("提交成功")
                }
          })
        }
      })
    },
    // 检品报告-查看
    checkReportView (url) {
      // CreatedUrl.openUrl(url)
      this.pdfViewDialogVisible = true;
      this.pdfurl = url
    },
    //检品报告-下载
    checkReportDownload (url) {
      CreatedUrl.urlDown(url, '检品报告书.pdf')
    },
    getAuthFreeStorageFee () {
      return window.sessionStorage.getItem("categoryPriceAUTH") == "true"
    },
    //免仓储费
    async freeStorageFee (row) {
      this.$confirm("确定免仓储费吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$http
            .post("order/exemptionFromStorageFee", row)
            .then(async ({ data }) => {
              if (data.code === 200) {
                this.$message({
                  type: "success",
                  message: "免仓储费成功!",
                })
                await this.getOrderList()
              }
            })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          })
        })
    },
    submitArrivalRemind () {
      // 提交数据
      this.$http
        .post("order/arrivalRemind", this.arrivalRemindInfo)
        .then(({ data }) => {
          if (data.code === 200) {
            this.arrivalRemindDialogVisible = false
            this.getOrderList()
            this.$message.success("提交成功")
          }
        })
    },
    arrivalRemind (row) {
      this.arrivalRemindInfo.orderId = row.id
      this.arrivalRemindInfo.arrivalRemindContent = row.arrivalRemindContent
      this.arrivalRemindDialogVisible = true
    },
    getPrice (price, goodsCount) {
      if (!price || !goodsCount) {
        return 0
      }
      price = Number(price)
      goodsCount = Number(goodsCount)
      return (price * goodsCount).toFixed(2)
    },
    /**
     * 批量更改账号
     */
    batchUpdateAccount () {
      // 没有选择账号给出错误提示
      if (!this.batchAccount.buyAccountId) {
        this.$message({ type: "warning", message: "请选择账号" })
        return false
      }

      // 隐藏弹窗
      this.accountDialogVisible = false
      // 遍历获取订单id数组
      this.batchAccount.idList = this.orderDetailList.map((item) => item.id)

      // 提交数据
      this.$http
        .post("order/batchUpdateBuyAccountId", this.batchAccount)
        .then(({ data }) => {
          if (data.code === 200) {
            this.getOrderList()
            this.getOrderCount()
            this.$message.success("提交成功")
          }
        })
    },
    downloadPdf (name, url) {
      let formdata = new FormData()
      formdata.append("FileUrl", url)
      formdata.append("FileName", name)
      this.$http({
        url: "aliyun/oss/download",
        method: "post",
        data: formdata,
        responseType: "blob", //关键点
      }).then((res) => {
        //下载文件操作
        const link = document.createElement("a")
        let blob = new Blob([res.data], { type: "" }) //生成blob对象
        link.style.display = "none"
        link.href = URL.createObjectURL(blob)
        link.setAttribute("download", name) //下载的文件名以及文件格式
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview () {
      return
    },
    // 文件列表移除文件时的钩子
    handleRemove () {
      return
    },
    // 删除文件之前的钩子
    beforeRemove () {
      return
    },
    // 文件上传成功时的钩子
    handleSuccess () {
      return
    },

    // 文件超出个数限制时的钩子
    handleExceed () {
      return
    },
    // 覆盖默认的上传行为
    async excelUploadRequest (file) {
      let formdata = new FormData()
      formdata.append("file", file.file)
      const { data: res } = await this.$http.post(
        "order/orderBatchUpdate",
        formdata
      )
      if (res.code === 200) {
        this.$message.success(`上传成功`)
      }
    },
    // 批量导入
    // async excelUploadRequest (file) {
    //   let formdata = new FormData();
    //   formdata.append('file', file.file);
    //   const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata);
    //   if (res.code === 200) {
    //     this.replyInfo.fileName = res.data.fileName
    //     this.replyInfo.filePath = res.data.filePath
    //     console.log(res)
    //   }
    // },
    //订单批量更新
    async orderExcelUpload (file) {
      let _self = this

      const isEXCEL =
        file.file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      if (!isEXCEL) {
        _self.$message.error("上传文件只能是 Excel 格式!")
        return
      }
      let formdata = new FormData()
      formdata.append("file", file.file)
      // formdata.append('modular', 'FBAContainer')
      if (isEXCEL) {
        formdata.append("type", "EXCEL")
      }
      _self.$http.post("order/orderBatchUpdate", formdata).then((res) => {
        if (res.data.code == 200) {
          _self.$message.success("上传成功")
        }
      })
    },
    handleCloseMark (id) {
      this.$http.post("order/closeEditFlag/" + id).then((res) => {
        if (res.data.code === 200) {
          this.getOrderList()
        }
      })
    },
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        // 接口start
        this.$http
          .get("menu/menuSetting", {
            params: {
              menuId: "staffOrders",
            },
          })
          .then((res) => {
            var result = []
            if (res.data.code === 200) {
              var record = res.data.data
              this.menuSettingData = record
              result = JSON.parse(record.menuSetting)
            }
            if (result && result.length > 0) {
              result.forEach((item) => {
                this.$set(item, "isShow", true)
              })
              let noSelectList = filterList(
                this.originColumns,
                result,
                "columnId"
              )
              this.columns = result.concat(noSelectList)
              this.asyncColumns = result
            } else {
              this.columns = this.originColumns
              this.columns.forEach((item) => {
                this.$set(item, "isShow", true)
              })
              this.asyncColumns = this.columns
            }
            this.$http.get("order/getOrderListIsShowPrice").then((isShowPriceRes)=>{
              this.isShowPrice = isShowPriceRes.data.data
              if (this.isShowPrice == '1'){
                this.asyncColumns = this.asyncColumns.filter(columns => columns.key !== 'trackingNumberCn' &&  columns.key !== 'buyAccountId' &&  columns.key !== 'buyOrderNumber' )
              }
              resolve()
            })
          })
      })
    },
    // 保存选择的列
    async doSaveColumns (list) {
      var my = this
      // 接口
      let url = "menu/updateMenuSetting"
      this.menuSettingData.menuSetting = JSON.stringify(list)
      this.$http.post(url, this.menuSettingData).then((res) => {
        if (res.data.code === 200) {
          this.isVisibleSort = false
          my.$message({
            type: "success",
            message: "保存成功",
          })
          this.queryInfo.pageNum = 1
          this.getAsyncColumns().then(() => {
            this.getOrderList()
          })
        } else {
          my.$message({
            type: "warning",
            message: "保存失败",
          })
        }
      })
    },
    // 排序
    toSort () {
      this.isVisibleSort = true
    },
    async optionchange (value, type, id) {
      // buyOrderNumber
      // buyAccountId
      if (!this.buyoutInfo.buyOrderNumber && type === 'ddh') {
        this.$message.error("请输入购买订单号")
        throw error("请输入购买订单号")
      }
      if (!this.buyoutInfo.buyAccountId && type === 'zh') {
        this.$message.error("请输入购买账号")
        throw error("请输入购买账号")
      }
      if (type === "ddh") {
        const { data: res } = await this.$http.post("/order/updateNotes", {
          orderId: id,
          buyOrderNumber: value,
        })
      } else {
        const { data: res } = await this.$http.post("/order/updateNotes", {
          orderId: id,
          buyAccountId: value,
        })
      }
    },
    // 编辑实际价格和历史价格
    async handelPrice (row) {
      let params = {
        orderId: row.id,
        actualPrice: row.actualPrice,
      }
      const { data: res } = await this.$http.post('/order/updateActualPrice', params)
      if (res.code == 200) {
        this.$message.success('操作成功！')
        this.getOrderList()
      }
    },
    //快速保存
    async quickSave (value, type, id, flag = false) {
      if(flag){
        console.log(flag)
        const params = {
          orderId: id,
          buyOrderNumber: value
        }
        const res = await this.$http.get("/order/updateOrderData", {params})
        console.log(res)
        // this.getOrderList()
      }else
      if (type === "0") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          productDesc: value,
          quickSaveType: type,
        })
      } else if (type === "1") {
        if (!value && value !== 0) {
          this.$message.error("中国运费不能设置为空")
        } else if (
          (value.split("")[0] == 0 && value.split("")[1] == 0) ||
          (value.split("")[0] == 0 &&
            value.split("").length > 1 &&
            value.split("")[1] !== ".")
        ) {
          this.$message.error("请正确输入运费！")
        }
        // else if ((value.split('0').length > 1 && value.split('0')[0] == undefined)||value.split(',').filter(val => Boolean(val) == false).length <= 1) {
        //   // this.buyoutInfo.chineseFreightFee = 0
        //   // this.buyoutInfo.chineseFreightFee = 0.00
        //   this.$message.error('请正确输入运费！')
        // }
        else {
          const { data: res } = await this.$http.post("/order/quickSave", {
            orderId: id,
            chineseFreightFee: value,
            quickSaveType: type,
          })
        }
      } else if (type === "2") {
        if (value && Number(value) > 0) {
          const { data: res } = await this.$http.post("/order/quickSave", {
            orderId: id,
            price: value,
            quickSaveType: type,
          })
        } else {
          this.$message.error("单价不能设置为空")
        }
      } else if (type === "3") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          buyOrderNumber: value,
          quickSaveType: type,
        })
      } else if (type === "4") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          buyAccountId: value,
          quickSaveType: type,
        })
      } else if (type === "5") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          staffRemark: value,
          quickSaveType: type,
        })
      } else if (type === "6") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          checkRemark: value,
          quickSaveType: type,
        })
      } else if (type === "7") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          productDescEn: value,
          quickSaveType: type,
        })
      } else if (type === "9") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          checkCoefficient: value,
          quickSaveType: type,
        })
      } else if (type === "10") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          materialZh: value,
          quickSaveType: type,
        })
      } else if (type === "11") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          materialEn: value,
          quickSaveType: type,
        })
      } else if (type === "12") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          purposeZh: value,
          quickSaveType: type,
        })
      } else if (type === "13") {
        const { data: res } = await this.$http.post("/order/quickSave", {
          orderId: id,
          purposeEn: value,
          quickSaveType: type,
        })
      }
    },
    async trackingNumberChange (value, id) {
      // const { data: res } = await
      this.$http
        .post("/order/orderListUpdateTrackNumberCn", {
          orderId: id,
          trackingNumberCn: value,
        })
        .then((res) => {
          if (res.data.code == "200") {
            // this.getOrderList();
          }
        })
    },
    async getAllList () {
      const { data: res } = await this.$http.get(
        "/cms/configAccountNumber/getAllList"
      )
      this.accountorderlist = res.data
    },
    onPasteUpload (event) {
      event.stopPropagation()
      let text = event.clipboardData || window.clipboardData
      this.bigimglist.upfile = text.files[0]
      this.bigimglist.pictureUrl = ""
      if (text.files[0] === null) {
        this.$message.error("仅支持图片文件")
      } else {
        // 将文件流转换为img认识的格式放在页面
        let blob = new Blob([text.files[0]]) // 返回的文件流数据
        let url = window.URL.createObjectURL(blob) // 将他转化为路径
        this.replyInfo.imgFileList = [{ url }]
        var su = document.getElementsByClassName("el-upload--picture-card")[0]
        this.$nextTick(() => {
          su.style.display = "none"
        })
      }
    },
    async getDropDownList () {
      const { data: res } = await this.$http.post(
        "cms/logisticsCompany/getDropDownList"
      )
      this.dropDownList = res.data
    },

    buyout (row) {
      console.log(row)
      this.buyoutvisible = true
      this.buyoutInfo.price = row.price
      this.buyoutInfo.goodsCount = row.goodsCount
      this.buyoutInfoonreade.userName = row.userName
      this.buyoutInfoonreade.id = row.id
      this.buyoutInfoonreade.splitOrderId = row.splitOrderId
      this.buyoutInfoonreade.splitSeq = row.splitSeq
      this.buyoutInfoonreade.price = row.price
      this.buyoutInfoonreade.num = row.goodsCount
      this.buyoutInfoonreade.historyPrice = row.historyPrice
      this.buyoutInfo.orderId = row.id
      this.buyoutInfo.chineseFreightFee = row.chineseFreightFee
      this.buyoutInfo.buyOrderNumber = row.buyOrderNumber
      this.buyoutInfo.buyAccountId = row.buyAccountId
      this.buyoutInfo.trackingNumberCn = row.trackingNumberCn
      this.buyoutInfo.cnLogisticsCompanyId = row.cnLogisticsCompanyId
      if (!row.trackingNumberCn) {
        row.trackingNumberCn = null
      }
      this.$set(this.buyoutInfo, "checkCoefficient", row.checkCoefficient || 1)
      this.$set(this.buyoutInfo, "trackingNumberCn", row.trackingNumberCn)
      this.$http.get("cms/configAccountNumber/getAllList").then((res) => {
        this.orderlist = res.data.data
      })
      this.getDropDownList()
    },
    cantBuy (row) {
      this.$confirm(
        "确认后不可更改，是否确认该商品切换成无库存状态？",
        "无库存",
        {
          confirmButtonText: "提交",
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: "取消",
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.post(
            `order/updateCantBuy/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: "无法购买成功!",
            })
            await this.getOrderList()
            this.getOrderCount()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消无法购买",
          })
        })
    },
    returned (row) {
      this.$confirm(
        "确认后不可更改，是否确认该商品退货并退还客户已扣除的费用？",
        "退货",
        {
          confirmButtonText: "提交",
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: "取消",
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          const { data: res } = await this.$http.post(
            `order/updateReturned/` + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: "退货成功!",
            })
            await this.getOrderList()
            this.getOrderCount()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退货",
          })
        })
    },
    getBuyAccountList () {
      this.$http.get("cms/configAccountNumber/getAllList").then((res) => {
        this.buyAcountList = res.data.data
        this.buyAcountList.map((res) => {
          if (res.platformType !== null) {
            switch (res.platformType) {
              case "0":
                return (res.platformType_hanzi = "淘宝 -" + res.accountNumber)
                break
              case "1":
                return (res.platformType_hanzi = "1688 -" + res.accountNumber)
                break
              case "2":
                return (res.platformType_hanzi = "京东 -" + res.accountNumber)
                break
              case "3":
                return (res.platformType_hanzi =
                  "拼多多 -" + res.accountNumber)
                break
              case null:
                return (res.platformType_hanzi = "")
                break
            }
          }
        })
      })
    },
    async Store (row) {
      this.Storevisible = true
      this.getDropDownList()
      // this.buyoutvisible=true
      this.buyoutInfoonreade.userName = row.userName
      this.buyoutInfoonreade.id = row.id
      this.buyoutInfoonreade.splitOrderId = row.splitOrderId
      this.buyoutInfoonreade.splitSeq = row.splitSeq
      this.buyoutInfoonreade.price = row.price
      this.buyoutInfoonreade.num = row.goodsCount
      this.StoreInfo.orderId = row.id

      const { data: res } = await this.$http.get("order/" + row.id)
      this.StoreInfo.inlandFreight = res.data.inlandFreight
      // this.StoreInfo.cnLogisticsCompanyId = res.data.cnLogisticsCompanyId;
      this.$set(
        this.StoreInfo,
        "cnLogisticsCompanyId",
        res.data.cnLogisticsCompanyId
      )
      this.$set(this.StoreInfo, "trackingNumberCn", res.data.trackingNumberCn)
    },
    async Returned (row) {
      this.returnedvisible = true
      this.buyoutInfoonreade.userName = row.userName
      this.buyoutInfoonreade.id = row.id
      this.returnedInfo.orderId = row.id
    },
    handleImgRemove2 (file) {
      Oss.imgRemove(file, this.listObj)
      var su = document.getElementsByClassName("el-upload--picture-card")[0]
      this.$nextTick(() => {
        su.style.display = "block"
      })
      this.bigimglist.upfile = ""
      this.bigimglist.pictureUrl = ""
    },
    imgclick (url, index) {
      this.index = index
      this.bigvisible = true
      if (url.pictureUrl == "" || url.pictureUrl == undefined) {
        this.$nextTick(() => {
          var su = document.getElementsByClassName(
            "el-upload--picture-card"
          )[0]
          su.style.display = "block"
          this.replyInfo.imgFileList = []
        })
      } else {
        this.$nextTick(() => {
          var su = document.getElementsByClassName(
            "el-upload--picture-card"
          )[0]
          su.style.display = "none"
          this.replyInfo.imgFileList = [
            {
              url: url.pictureUrl,
            },
          ]
        })
      }
      this.bigimglist.orderId = url.id
      var su = document.getElementsByClassName("el-upload-list__item")[0]
      document.addEventListener("paste", this.onPasteUpload)
    },
    imgDialogClose () {
      this.bigvisible = false
      if (this.replyInfo.imgFileList.length === 0) {
        var su = document.getElementsByClassName("el-upload--picture-card")[0]
        this.$nextTick(() => {
          su.style.display = "block"
        })
      } else {
        var su = document.getElementsByClassName("el-upload--picture-card")[0]
        this.$nextTick(() => {
          su.style.display = "none"
        })
      }
    },
    async uploadFile () {
      var formdata = new FormData()
      formdata.append("orderId", this.bigimglist.orderId)
      var su = this.orderList[this.index].pictureUrl
      this.bigimglist.pictureUrl === undefined
        ? formdata.append("pictureUrl", su)
        : formdata.append("pictureUrl", this.bigimglist.pictureUrl)

      formdata.append("upfile", this.bigimglist.upfile)
      const { data: res } = await this.$http.post("order/uploadFile", formdata)
      if (res.code === 200) {
        this.$message.success("上传成功")
        this.bigvisible = false
        this.getOrderCount()
        this.getOrderList()
      } else {
        this.$message.error(res.message)
      }
    },
    imgSave () {
      this.handleImgSubmit()

      if (this.replyInfo.replyPicture.indexOf(",")) {
        this.replyInfo.replyPicture = this.replyInfo.replyPicture.split(",")[1]
      }

      if (this.bigimglist.upfile === "") {
        this.bigimglist.pictureUrl = this.replyInfo.replyPicture
      } else {
        this.bigimglist.pictureUrl = ""
      }
      this.replyInfo.imgFileList = this.replyInfo.imgFileList.splice(1, 1)
      this.uploadFile()
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    orderDateRange () { },
    shipDateRange () { },
    //拆单按钮显示
    showSplitOrderBtn (row) {
      if (
        row.orderStatus == 0 ||
        row.orderStatus == 1 ||
        row.orderStatus == 2 ||
        row.orderStatus == 4 ||
        row.orderStatus == 8 ||
        row.orderStatus == 12 ||
        row.orderStatus == 16
      ) {
        if (row.goodsCount > 1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }, //编辑按钮显示
    showEditBtn (status) {
      if (
        status == 0 ||
        status == 1 ||
        status == 2 ||
        status == 4 ||
        status == 8 ||
        status == 16 ||
        status == 24 ||
        status == 26 ||
        status == 28 ||
        status == 32 ||
        status == 36 ||
        status == 82 ||
        status == 40 ||
        status == 60 ||
        status == 76
      ) {
        return true
      } else {
        return false
      }
    },
    //账单按钮显示   已销毁84 已退货72 已发送52 待退货68 装箱中88 待发送48 销毁待支付80 待支付44 退货待支付64
    // showBill (status) {
    //   if (status == 84 || status == 72 || status == 52 || status == 68 || status == 88 || status == 48 || status == 80 || status == 44 || status == 64) {
    //     return true;
    //   }
    //   else {
    //     return false;
    //   }
    // },
    //发送账单按钮显示  检品完12 申请发货20 退货申请中60 销毁申请中76
    // showSendBill (status) {
    //   if (status == 12 || status == 20 || status == 60 || status == 76) {
    //     return true;
    //   }
    //   else {
    //     return false;
    //   }
    // },
    // addBill (e) {
    //   this.$router.push({
    //     path: 'orders/bill',
    //     query: {
    //       id: e.id,
    //       isAdd: '0',
    //       //orderNumber:e.orderNumber,
    //     }
    //   })
    // },
    // addSendBill (e) {
    //   this.$router.push({
    //     path: 'orders/bill',
    //     query: {
    //       id: e.id,
    //       isAdd: '1',
    //       //orderNumber:e.orderNumber,
    //     }
    //   })
    // },
    queryInfoClear () {
      (this.curIndex = 0), (this.queryInfo.orderStatus = "");
      (this.queryInfo.buyAccountId = ""),
        (this.queryInfo.userName = ""),
        (this.queryInfo.id = ""),
        (this.queryInfo.trackingNumberCn = ""),
        (this.queryInfo.trackingNumberJpn = ""),
        (this.queryInfo.sagawaState = ""),
        // orderStatus: '',
        // orderStatusList:[],
        (this.queryInfo.customerName = ""),
        (this.queryInfo.buyOrderNumber = ""),
        (this.queryInfo.receiver = ""),
        (this.queryInfo.categoryFlag = ""),
        (this.queryInfo.createTimeStart = ""),
        (this.queryInfo.createTimeEnd = ""),
        (this.queryInfo.sendTimeStart = ""),
        (this.queryInfo.sendTimeEnd = ""),
        (this.queryInfo.orderType = ""),
        (this.queryInfo.whetherStorageFee = ""),
        (this.queryInfo.goodsCode = ""),
        (this.queryInfo.pageSize = 10),
        (this.queryInfo.pageNum = 1),
        (this.queryInfo.isCnLogisticsStatusUpdate = '')
      // this.orderDateRangeValue = '';
      // this.shipDateRangeValue = [];
    },
    searchList (status, index) {
      if (index || index == 0) {
        this.curIndex = index
      }
      if (status == -1) {
        //全部
        this.queryInfo.orderStatus = ""
      } else if (status == 1) {
        //待购买
        this.queryInfo.orderStatus = "1"
      } else if (status == 2) {
        //购买完
        this.queryInfo.orderStatus = "2"
      } else if (status == 0) {
        //等待到库
        this.queryInfo.orderStatus = "0"
      } else if (status == 4) {
        //已到货（到库，检品中，检品完，申请发货，装箱中，待发送）
        // this.queryInfo.orderStatus = '4,8,12,20,48,88';
        //已到货（到库，检品中，装箱中，待发送）
        this.queryInfo.orderStatus = "4,8,48,88"
      } else if (status == 5) {
        //仓库保管中
        this.queryInfo.orderStatus = "16"
      } else if (status == 6) {
        //待支付、退货待支付、销毁待支付
        this.queryInfo.orderStatus = "44,64,80"
      } else if (status == 7) {
        //不良订单（不良待处理，换货待发回，换货待到货，待部分退货，退货待支付，退货申请中，待退货，补发等待到货，销毁申请中，销毁待支付，待部分销毁，不良驳回）
        // this.queryInfo.orderStatus = '24,28,32,36,68,64,40,76,80,82,26,60';
        //不良订单（不良待处理，换货待发回，换货待到货，待部分退货，待退货，补发等待到货，待部分销毁，不良驳回）
        this.queryInfo.orderStatus = "24,28,32,36,68,40,82,26"
      } else if (status == 8) {
        //已完成（已发送，已退货，已销毁）
        this.queryInfo.orderStatus = "52,72,84"
      } else if (status == 9) {
        //代发账单(检品完、申请发货、退货申请中、销毁申请中)
        this.queryInfo.orderStatus = "12,20,60,76"
      } else if (status == 10) {
        //无法购买(无法购买)
        this.queryInfo.orderStatus = "89"
      } else if (status == 11) {
        //已取消(已取消)
        this.queryInfo.orderStatus = "56"
      }
      this.queryInfo.pageNum = 1
      this.getOrderCount()
      this.getOrderList()
    },
    categoryFlagChanged (row) {
      //改变状态接口 params row.No,row.categoryFlag
      setTimeout(() => {
        row.categoryFlag = !row.categoryFlag
        alert("failed")
      }, 1000)
    },
    async getOrderList () {
      console.log(123)
      this.isLoading = true
      // let params = {}
      // Object.assign(params, this.queryInfo)
      // params.orderId = params.id
      // params.id = undefined
      const { data: res } = await this.$http.get("order/listByStaff", {
        params: this.queryInfo
      })
      if(res.code!==200){
        this.$message.error(res.message)
        this.isLoading = false
        return
      }
      res.data.list.map((res) => {
        var flag = false
        this.buyAcountList.map((item) => {
          if (item.id === res.buyAccountId && res.buyAccountId !== null) {
            flag = true
          }
        })
        if (!flag) {
          res.buyAccountId = null
        }
      })
      this.orderList = res.data.list
      this.$forceUpdate()
      this.total = res.data.total
      this.$nextTick(() => {
        // console.log(this.$refs.draggableTable.$refs.table,1122)
        this.$refs.draggableTable.$refs.table?.doLayout(); // table
      });
      this.isLoading = false
    },
    async getOrderCount () {
      // let params = {}
      // Object.assign(params, this.queryInfo)
      // params.orderId = params.id
      // params.id = undefined
      const { data: res } = await this.$http.get("order/orderCount", {
        params:this.queryInfo
      })
      this.orderCount = res.data
      this.$forceUpdate()
    },
    toOrderDetail (row) {
      this.$router.push({
        name: "orderDetail",
        query: {
          id: row.id,
          customerId: row.customerUserId,
          isEdit: "0",
        },
      })
    },
    toGoodsDetail (row) {
      this.$http.get('/purchase/changeUrlAction', { params: { url: row.taobaoUrl } }).then((res) => {
        const changeUrl = res.data.data
        console.log(changeUrl)
        window.open(changeUrl, "_blank")
      })
      /*this.$http
          .post("/order/changeUrl", { taobaoUrl: row.taobaoUrl })
          .then((res) => {
            const changeUrl = res.data.data;
            console.log(changeUrl);
            window.open(changeUrl, "_blank");
          });*/
    },
    toEditOrder (row) {
      this.$router.push({
        name: "orderDetail",
        query: {
          id: row.id,
          customerId: row.customerUserId,
          isEdit: "1",
        },
      })
    },
    splitOrder (row) {
      this.splitDialogVisible = true
      this.orginSplitOrderInfo = row
      this.splitOrderInfo = JSON.parse(JSON.stringify(row))
    },
    splitDialogClosed () {
      this.splitDialogVisible = false
    },
    splitSave (formName) {
      this.$refs[formName].validate(async (valid) => {
        let params = {
          id: this.splitOrderInfo.id,
          goodsCount: this.splitOrderInfo.goodsCount,
          refundCount: this.splitOrderInfo.refundCount,
          destroyCount: this.splitOrderInfo.destroyCount,
        }
        if (valid) {
          const { data: res } = await this.$http.post(
            "empArrOrder/spilt",
            params
          )
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.message,
            })
            this.splitDialogClosed()
            await this.getOrderCount()
            await this.getOrderList()
          } else {
            this.$message({
              type: "warning",
              message: res.message,
            })
          }
        }
      })
    },
    saveRemark (row) {
      this.savePost(row)
    },
    async savePost (row) {
      const { data: res } = await this.$http.post("order/updateNotes", {
        orderId: row.id,
        staffRemark: row.staffRemark,
      })
      if (res.code == 200) {
        this.getOrderCount()
        this.getOrderList()
      } else {
        this.$message.error(res.message)
        this.getOrderCount()
        this.getOrderList()
      }
    },
    async saveProductDesc (row) {
      const { data: res } = await this.$http.post("order/updateNotes", {
        orderId: row.id,
        productDesc: row.productDesc,
      })
      if (res.code == 200) {
        this.getOrderCount()
        this.getOrderList()
      } else {
        this.$message.error(res.message)
        this.getOrderCount()
        this.getOrderList()
      }
    },

    async updatePurchaseStatus (parms) {
      const { data: res } = await this.$http.post(
        "order/updatePurchaseStatus",
        parms
      )
      if (res.code === 200) {
        this.$message.success("操作成功")
        this.buyoutvisible = false
        this.getOrderCount()
        this.getOrderList()
      } else {
        this.$message.error(res.message)
      }
    },
    buyoutSave (formName) {
      //提醒弹窗保存按钮
      // this.buyoutInfo.price = this.buyoutInfoonreade.price
      // this.buyoutInfo.goodsCount = this.buyoutInfoonreade.num

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.optionchange();
          // alert(1);
          // return;
          this.updatePurchaseStatus(this.buyoutInfo)
        }
      })
    },
    buyoutDialogClose () {
      //关闭提醒弹窗
      this.buyoutvisible = false
      this.$refs.buyoutInfo.resetFields
      this.buyoutInfo = {
        orderId: "",
        buyAccountId: "",
        configLogisticsCompanyId: "",
        buyOrderNumber: "",
        inlandFreight: "",
        trackingNumberJpn: "",
        trackingNumberCn: "",
      }
    },
    //取消购买完
    async cancelPurchaseStatus (row) {
      this.$confirm("确定取消购买吗？相应费用会退还至用户账户。", "取消购买", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          this.buyoutInfo.orderId = row.id
          const { data: res } = await this.$http.post(
            "order/cancelPurchaseStatus/" + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: "取消购买完成功!",
            })
            await this.getOrderList()
            this.getOrderCount()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          })
        })
    },
    //取消收货
    async cancelCheckIn (row) {
      this.$confirm("确定取消收货吗？", "取消收货", {
        confirmButtonText: "提交",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      })
        .then(async () => {
          this.buyoutInfo.orderId = row.id
          const { data: res } = await this.$http.post(
            "order/cancelCheckIn/" + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: "取消收货成功!",
            })
            await this.getOrderList()
            this.getOrderCount()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          })
        })
    },
    //取消检品
    async cancelCheck (row) {
      this.$confirm(
        "确定取消检品吗？如果已检品完会退还相应费用给客户。",
        "取消检品",
        {
          confirmButtonText: "提交",
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: "取消",
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        }
      )
        .then(async () => {
          this.buyoutInfo.orderId = row.id
          const { data: res } = await this.$http.post(
            "order/cancelCheck/" + row.id
          )
          if (res.code !== 200) {
            this.$message.error(res.message)
          } else {
            this.$message({
              type: "success",
              message: "取消检品成功!",
            })
            await this.getOrderList()
            this.getOrderCount()
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          })
        })
    },
    async updateSendStatus (parms) {
      const { data: res } = await this.$http.post(
        "order/updateSendStatus",
        parms
      )
      if (res.code === 200) {
        this.$message.success("操作成功")
        this.Storevisible = false
        this.getOrderCount()
        this.getOrderList()
      } else {
        this.$message.error(res.message)
      }
    },
    StoreSave (formName) {
      //提醒弹窗保存按钮
      // console.log('this.StoreInfo',this.StoreInfo)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.Storevisible = false
          this.getOrderCount()
          this.getOrderList()
          this.updateSendStatus(this.StoreInfo)
        }
      })
    },
    StoreDialogClose () {
      //关闭提醒弹窗
      this.Storevisible = false
      this.$refs.StoreInfo.resetFields
      this.StoreInfo = {
        orderId: "",
        inlandFreight: "",
        configLogisticsCompanyId: "",
        trackingNumberJpn: "",
        trackingNumberCn: "",
      }
    },
    ReturnedSave (formName) {
      //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateReturned(this.returnedInfo)
        }
      })
    },
    ReturnedDialogClose () {
      //关闭提醒弹窗
      this.returnedvisible = false
      this.$refs.returnedInfo.resetFields
      this.returnedInfo = {
        orderId: "",
        refundServiceFee: 5.0,
        returnFee: 0.0,
      }
    },
    async updateReturned (parms) {
      const { data: res } = await this.$http.post(
        "order/updateReturned",
        parms
      )
      if (res.code === 200) {
        this.$message.success("操作成功")
        this.returnedvisible = false
        this.getOrderCount()
        this.getOrderList()
      } else {
        this.$message.error(res.message)
      }
    },
    remind (row) {
      //提醒
      this.replyMessageInfo = row
      this.isVisiable = true
    },
    onConfirmMsg () {
      this.isVisiable = false
      this.getOrderCount()
      this.getOrderList()
    },
    clearReplyForm () {
      //弹窗的取消按钮
      this.initReplyForm()
      this.replyDialogVisible = false
    },
    initReplyForm () {
      //初始化弹窗的内容
      this.replyInfo = {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
      }
    },

    showImgDialog (index) {
      this.imgDialogVisible = true
    },
    handleImgSubmit () {
      var _this = this
      let arr = []
      Object.keys(_this.listObj).map((v) => {
        arr.push(_this.listObj[v])
      })
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(
          "请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！"
        )
        return
      } else {
        if (arr.length > 1) {
          _this.$message.error("最多可上传1张图片")
        } else {
          _this.replyInfo.imgFileList = _this.replyInfo.imgFileList.concat(arr)
          var urlArr = []
          _this.replyInfo.imgFileList.forEach((el) => {
            urlArr.push(el.url)
          })
          _this.replyInfo.replyPicture = urlArr.toString()
          _this.$emit("successCBK", arr)
          _this.listObj = {}
          _this.imgDialogVisible = false
        }
      }
    },

    handleImgSuccess2 (response, file, fileList) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj)
      var su = document.getElementsByClassName("el-upload--picture-card")[0]
      this.$nextTick(() => {
        su.style.display = "none"
      })
    },
    beforeImgUpload (file) {
      const _self = this
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        _self.$message.error("请上传jpg,jpeg,png格式的图片！")
        return false
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/
      if (specialReg.test(file.name)) {
        _self.$message.error(
          "文件名中不能包含以下字符 ，；：｛｝* 请检查后修改文件名后再上传"
        )
        return false
      }
      const fileName = file.uid
      this.listObj[fileName] = {}
      return new Promise((resolve, reject) => {
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = "" //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10)
            }
            num = new Date().getTime() + num //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy
            _self.imgDataObj.signature = response.data.data.signature
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId
            _self.imgDataObj.key =
              response.data.data.dir + "/order/" + num + "${filename}"
            _self.imgDataObj.dir = response.data.data.dir + "/order"
            _self.imgDataObj.host = response.data.data.host
            _self.imgDataObj.timeStamp = num
            file.timeStamp = num
            Oss.imgCompress(file, this.listObj, resolve, reject)
          })
          .catch((err) => {
            reject(true)
          })
      })
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getOrderCount()
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage
      this.getOrderCount()
      this.getOrderList()
    },
    tableSelect (selection) {
      this.tableSelectAll(selection)
    },
    // 手搓复选框用的
    // tableSelect (val, row) {
    //   if (val) {
    //     this.orderDetailList.push(row)
    //     this.ids.push(row.id)
    //   } else {
    //     const index = this.orderDetailList.findIndex(item => item.id === row.id)
    //     if (index > -1) {
    //       this.orderDetailList.splice(index, 1)
    //       this.ids.splice(index, 1)
    //     }
    //   }
    // },
    tableSelectAll (selection) {
      this.orderDetailList = []
      this.ids = []
      selection.forEach((item) => {
        this.orderDetailList.push(item)
        this.ids.push(item.id)
      })
    },
    cancelBatchUpdatePurchaseStatus () {
      if (this.orderDetailList.length > 0) {
        this.$confirm("确定批量取消购买吗？相应费用会退还至用户账户。", "取消购买", {
          confirmButtonText: "提交",
          confirmButtonClass: "form-btn btn-blue",
          cancelButtonText: "取消",
          cancelButtonClass: "form-btn btn-gray",
          type: "warning",
        })
          .then(async () => {
            this.$http
              .post("order/cancelBatchUpdatePurchaseStatus", this.orderDetailList)
              .then((res) => {
                if (res.data.code === 200) {
                  this.$message.success("操作成功")
                  this.getOrderCount()
                  this.getOrderList()
                } else {
                  this.$message.error(res.data.message)
                  this.getOrderCount()
                  this.getOrderList()
                }
              })
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            })
          })
      } else {
        this.$message({
          type: "warning",
          message: "请先选择订单",
        })
      }
    },
    batchUpdatePurchaseStatus () {
      console.log(this.orderDetailList)

      if (this.orderDetailList.length > 0) {
        const flag = this.orderDetailList.some(it => {
          return !it.chineseFreightFee || !it.price || !it.buyOrderNumber || !it.buyAccountId
        })
        if (!flag) {
          this.$http
            .post("order/batchUpdatePurchaseStatus", this.orderDetailList)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success("操作成功")
                this.getOrderCount()
                this.getOrderList()
              } else {
                this.$message.error(res.data.message)
              }
            })
        } else {
          this.$message.error("所选数据含有未填写的'中国运费'、'单价'、'购买订单号'、'购买账号'")
        }
      } else {
        this.$message({
          type: "warning",
          message: "请先选择订单",
        })
      }
    },
    // 导出加购
    async exportActionTwo () {
      this.getNowFormatDate()
      if (this.queryInfo.createTimeStart == "" || this.queryInfo.createTimeEnd == '') {
        this.$message({
          type: "warning",
          message: "下单时间段不能为空",
        })
        return
      }
      let startTime = new Date(this.queryInfo.createTimeStart).getTime()
      let endTime = new Date(this.queryInfo.createTimeEnd).getTime()
      if (startTime > endTime) {
        this.$message({
          type: "warning",
          message: "开始时间不能大于结束时间",
        })
        return
      }
      if (endTime - startTime > (60 * 60 * 24 * 365 * 1000)) {
        this.$message({
          type: "warning",
          message: "间隔不能大于一年",
        })
        return
      }
      this.$http({
        url: "order/exportShoppingCart",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        params: this.queryInfo,
        data: {
          //接口参数
        },
      })
          .then((res) => {
            //创建一个隐藏的a连接，
            const link = document.createElement("a")
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
            link.style.display = "none"
            //设置连接
            link.href = URL.createObjectURL(blob)
            link.download = `导出加购${this.currentdate}.xlsx`
            document.body.appendChild(link)
            //模拟点击事件
            link.click()
          })
          .catch((err) => {
            // console.log(err);
          })
    },
    async exportAction () {
      this.$http({
        url: "order/exportAction",
        method: "get",
        params: this.queryInfo,
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a")
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
          link.style.display = "none"
          //设置连接
          link.href = URL.createObjectURL(blob)
          link.download = "订单列表.xlsx"
          document.body.appendChild(link)
          //模拟点击事件
          link.click()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //订单导出
    orderExport () {
      this.getNowFormatDate()
      // var params = qs.stringify({
      //   token: window.sessionStorage.getItem('token'),
      //   id: id
      // })
      // window.location.href = "/api/container/exportInvoice?id=" + id

      // let url = '/api/container/exportInvoice?id=' + id
      // window.location.href = `${url}`

      if (this.queryInfo.createTimeStart == "" || this.queryInfo.createTimeEnd == '') {
        this.$message({
          type: "warning",
          message: "下单时间段不能为空",
        })
        return
      }

      let startTime = new Date(this.queryInfo.createTimeStart).getTime()
      let endTime = new Date(this.queryInfo.createTimeEnd).getTime()

      if (startTime > endTime) {
        this.$message({
          type: "warning",
          message: "开始时间不能大于结束时间",
        })
        return
      }

      if (endTime - startTime > (60 * 60 * 24 * 365 * 1000)) {
        this.$message({
          type: "warning",
          message: "间隔不能大于一年",
        })
        return
      }

      this.$http({
        url: "order/exportOrder",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        params: this.queryInfo,
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a")
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
          link.style.display = "none"
          //设置连接
          link.href = URL.createObjectURL(blob)
          link.download = `订单列表${this.currentdate}.xlsx`
          document.body.appendChild(link)
          //模拟点击事件
          link.click()
        })
        .catch((err) => {
          // console.log(err);
        })
    },
    // getRowHeight(row, rowIndex) {
    //   return {
    //     position: 'relative',
    //     '&::before': {
    //       content: `"${rowIndex + 1}"`,
    //       position: 'absolute',
    //       left: '50%',
    //       top: '20%',
    //       transform: 'translateX(-50%)',
    //       fontSize: '14px',
    //       color: 'red'
    //     }
    //   };
    // },
    // 当前日期
    getNowFormatDate () {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      if (month >= 1 && month <= 9) month = "0" + month // 如果月份是个位数，在前面补0
      if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate // 如果日是个位数，在前面补0
      this.currentdate = `${year}${month}${strDate}${hour}${minute}${second}`
    },
    async updateSelect () {
      this.$forceUpdate()
    },

    //保存清除订单数据时间
    // async orderClearTimeSave() {
    //   let parms = {
    //     moduleName:"orderManagerWeb"
    //   }
    //   const { data: res } = await this.$http.post("orderClear/save", parms);
    //   if (res.code === 200) {
    //     this.$message.success('操作成功')
    //     this.getOrderCount();
    //     this.getOrderList()
    //   } else {
    //     this.$message.error(res.message)
    //   }
    // },

    //播放视频
    handlePlayVideo (param) {
      window.open(param, "_blank")
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    // orderDateRangeValue(){
    //   //解决时间选择器清空后 绑定值为null问题
    //   if(!this.orderDateRangeValue){
    //     this.orderDateRangeValue = '';
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   }
    //   else{
    //     if(this.orderDateRangeValue.length>0){
    //       this.queryInfo.createTimeStart = this.orderDateRangeValue;
    //       this.queryInfo.createTimeEnd = this.orderDateRangeValue;
    //     }
    //   }
    //
    // },
    // shipDateRangeValue(){
    //   if(!this.shipDateRangeValue){
    //     this.shipDateRangeValue =[];
    //     this.queryInfo.sendTimeStart = '';
    //     this.queryInfo.sendTimeEnd = '';
    //   }
    //   else{
    //     if(this.shipDateRangeValue.length>0){
    //       this.queryInfo.sendTimeStart = this.shipDateRangeValue[0];
    //       this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1];
    //     }
    //   }
    // }

    // 手搓复选框要用到的方法
    // orderList: {
    //   handler(newList, oldList) {
    //     if (!newList || !oldList) return;

    //     // 找出发生变化的数据
    //     const changedItem = newList.find((newItem, index) => {
    //       const oldItem = oldList[index];
    //       return oldItem && newItem.id === oldItem.id && JSON.stringify(newItem) !== JSON.stringify(oldItem);
    //     });

    //     if (changedItem) {
    //       // 更新 orderDetailList 中对应的数据
    //       const detailIndex = this.orderDetailList.findIndex(item => item.id === changedItem.id);
    //       if (detailIndex !== -1) {
    //         // 使用 Vue.set 或数组方法确保响应式更新
    //         this.$set(this.orderDetailList, detailIndex, { ...changedItem });
    //       }
    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    order1 () {
      if (!sessionStorage.getItem("token")) {
        return false
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/
  /*去除upload组件过渡效果*/
.el-upload-list__item {
  transition: none !important;
}

.bigimg /deep/ ul li {
  width: 100%;
  height: auto;
}

.bigimg /deep/ .el-upload--picture-card {
  display: none;
}

.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-table {
  ::v-deep tbody {
    tr {
      td:first-of-type {
        // 你的样式写这里
        border-right: none;
        .cell{
          padding: 0!important;
          text-align: right;
        }
      }
    }
  }
  ::v-deep thead {
    tr {
      th:first-of-type {
        // 你的样式写这里
        border-right: none;
        .cell{
          padding-right: 0!important;
        }
      }
    }
  }
}


.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.split-col {
  padding-right: 20px;
}

.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container-status {
  text-align: left !important;
}

.mark {
  background: #dbdb86;
  text-align: left;
  margin-bottom: 10px;
}

.el-icon-close {
  cursor: pointer;
}

.dialog-account {
  display: flex;
  flex-wrap: wrap;

  /deep/.el-radio {
    width: 28%;
    margin-bottom: 10px;
  }
}
.font-style {
  display: flex;
  justify-content: center;
  // justify-content: space-between;
  .left {
    display: flex;
    justify-content: flex-end;
    width: 60px;
    // min-width: 40px;
  }
  .right {
    min-width: 25px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
  }
}
.font-style1 {
  display: flex;
  justify-content: center;
  // justify-content: space-between;
  .left {
    display: flex;
    justify-content: flex-start;
    // width: 50px;
    min-width: 70px;
  }
  .right {
    min-width: 25px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
  }
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.flex-column {
  display: flex;
  flex-direction: column;
}

.set-number{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  div{
    width: 50%;
    display: flex;
    align-items: center;
    .w60{
      min-width: 57px;
      max-width: 57px;
      width: 57px!important;
      white-space: nowrap;
      text-align: right;
    }
  }
}
.all{
  width: 100%;
  display: flex;
  align-items: center;
  .item{
    min-width: 57px;
    max-width: 57px;
    width: 57px!important;
    white-space: nowrap;
    text-align: right;
  }
}

::v-deep .draggableTable {
  //thead {
  //  margin-top: 8px;
  //  tr {
  //    th:first-of-type {
  //      // 你的样式写这里
  //      border-right: none !important;
  //      .cell {
  //        padding-right: 0 !important;
  //      }
  //    }
  //    th:nth-of-type(2) {
  //      // 第二个 th 的样式
  //      //border-left: none;
  //      .cell {
  //        position: absolute !important;
  //        right: 0px !important;
  //        top: 9px !important;
  //      }
  //    }
  //  }
  //}
  //tbody {
  //  margin-top: 7px;
  //  tr {
  //    td:first-of-type {
  //      // 你的样式写这里
  //      border-right: none !important;
  //      .cell {
  //        padding: 0 !important;
  //        text-align: right !important;
  //      }
  //    }
  //  }
  //}
  tbody {
    tr {
      td:first-of-type {
        // 你的样式写这里
        border-right: none;
        .cell{
          padding: 0!important;
          text-align: right;
          width: 20px;
        }
      }
    }
  }
  thead {
    tr {
      th:first-of-type {
        // 你的样式写这里
        border-right: none;
        .cell{
          padding-right: 0!important;
          width: 20px;
        }
      }
    }
  }
}

.freeStorageDurationInfo /deep/ .el-form-item__error{
  left: 120px;
}

/*.table-one {
  ::v-deep .el-table{
    height: calc(100vh - 470px);

  }
}
.table-two {
  ::v-deep .el-table{
    height: calc(100vh - 300px);

  }
}*/
</style>
